<template>
	<div ref="gaokaolist" style="width: 100%;margin: 0 auto;overflow: auto;" :style="{ height: windowHeight + 'px' }" @scroll="loadData">
		<section class="gaokao-content" style="width: 1400px;margin: 0 auto;">
			<div class="centerWidth ">
				<section class="xtianbao_h1 "><div class="my-title">一键智能填报</div></section>
			</div>
			<div class="">
				<div class="centerWidth flex end float" style="width: 1400px;padding-bottom: 0;overflow: inherit;position: relative;z-index: 2;">
					<div class="pt_left tb_padding" style="width: 100%;">
						<article>
							<ul class="gkTest-step">
								<li>
									<div class="step-con step-on flex zhong center">
										<div>
											<img src="../../../image/zn_aa.png" />
											<span>基本信息</span>
										</div>
									</div>
								</li>
								<li>
									<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
								</li>
								<li>
									<div class="step-con step-on flex zhong center">
										<div>
											<img src="../../../image/zn_bb.png" />
											<span>意向选择</span>
										</div>
									</div>
								</li>
								<li>
									<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
								</li>
								<li>
									<div class="step-con step-on flex zhong center">
										<div>
											<img src="../../../image/zn_cc.png" />
											<span>精确选择</span>
										</div>
									</div>
								</li>
								<li>
									<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
								</li>
								<li>
									<div class="step-con flex zhong center">
										<div>
											<img src="../../../image/zn_d.png" />
											<span>生成志愿表</span>
										</div>
									</div>
								</li>
							</ul>
						</article>

						<div class="three_div flex ">
							<p :class="isTab == 0 ? 'on' : ''" @click="xuanZeTo(0)">专业选择</p>
							<p :class="isTab == 1 ? 'on' : ''" @click="xuanZeTo(1)">院校选择</p>
						</div>
						<!-- 专业选择 -->
						<div class="div_padding">
							<ul>
								<div v-show="isTab === 0">
									<li class=" flex zhong">
										<div class="tba_dl flex zhong">
											<label>批次选择：</label>
											<div class="tba_input">
												<el-select v-model="pcvalue" placeholder="请选择批次">
													<el-option v-for="item in BatchList" :key="item" :label="item" :value="item"></el-option>
												</el-select>
											</div>
										</div>

										<div class="tba_dl flex zhong">
											<label>选考科目：</label>
											<div class="tba_input" style="display: flex;">
												<!-- <el-select v-model="preferredSubject" @change="handlePreferredSubjectChange" multiple collapse-tags placeholder="请选择首选科目">
													<el-option v-for="item in oneOptions" :key="item" :label="item" :value="item"></el-option>
												</el-select> -->
												<el-select
													v-model="requirementsSubjects"
													@change="handleRequirementsSubjectsChange"
													multiple
													collapse-tags
													style="margin-left: 20px;"
													placeholder="请选择选考科目"
												>
													<el-option v-for="item in twoOptions" :key="item" :label="item" :value="item"></el-option>
												</el-select>
											</div>
										</div>
										<div class="tba_dl flex zhong">
											<label>专业名称：</label>
											<div class="tba_input" style="position: relative;">
												<!-- @input="querySearchAsync" @blur="querySearch" -->
												<el-input placeholder="请输入院专业名称" v-model="majorModel.searchMajorName"></el-input>
												<!-- <div class="pt_yuan"
													v-show="serchZyList && serchZyList.length > 0 && zyNameListPop">
													<ul>
														<li v-for="(item, index) in serchZyList" :key="index"
															@click="handleSelect(item)">
															<span v-html="item.ProfessionalName"></span>
														</li>
													</ul>
												</div> -->
											</div>
										</div>
									</li>
									<li class=" flex zhong">
										<!-- <div class="tba_dl flex zhong">
											<label>学科门类：</label>
											<div class="tba_input">
												<el-select v-model="xkvalue" collapse-tags multiple placeholder="请选择学科门类" @change="setSubjectCategories">
													<el-option v-for="item in xkoptions" :key="item" :label="item" :value="item"></el-option>
												</el-select>
											</div>
										</div>
										<div class="tba_dl flex zhong">
											<label>专业类：</label>
											<div class="tba_input">
												<el-select collapse-tags v-model="zyvalue" multiple placeholder="请选择学专业类" @change="setProfessional">
													<el-option v-for="item in zyoptions" :key="item" :label="item" :value="item"></el-option>
												</el-select>
											</div>
										</div>
										<div class="tba_dl flex zhong">
											<label>专业：</label>
											<div class="tba_input">
												<el-select v-model="zyavalue" multiple placeholder="请选择专业">
													<el-option v-for="item in zyaoptions" :key="item" :label="item" :value="item"></el-option>
												</el-select>
											</div>
										</div> -->
										
									</li>
									<li class=" flex zhong">
										<div class="tba_dl flex zhong">
											<label>院校名称：</label>
											<div class="tba_input">
												<div class="tba_input" style="position: relative;">
													<!-- @input="querySearchYx" @blur="queryYx" -->
													<el-input placeholder="请输入院校名称" v-model="majorModel.searchCollegesName"></el-input>
													<!-- <div class="pt_yuan"
														v-show="serchYXList && serchYXList.length > 0 && YXNameListPop">
														<ul>
															<li v-for="(item, index) in serchYXList" :key="index"
																@click="handleSelectYX(item)">
																<span v-html="item.CollegesName"></span>
															</li>
														</ul>
													</div> -->
												</div>
											</div>
										</div>

										<!-- <div class="tba_dl flex zhong">
                                <label>院校地区：</label>
                                <div class="tba_input" v-if="isTab === 0">
                                    <el-select v-model="majorSearchCitysCode" @change="handleSearchCitysCodeChange" multiple collapse-tags placeholder="请选择院校地区">
                                        <el-option v-for="item in threeOptions" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                                    </el-select>
                                </div>
                                <div class="tba_input" v-else>
                                    <el-select v-model="collegeSearchCitysCode" @change="handleSearchCitysCodeChange" multiple collapse-tags placeholder="请选择院校地区">
                                        <el-option v-for="item in threeOptions" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                                    </el-select>
                                </div>
                            </div> -->
										<div class="tba_dl flex zhong">
											<button class="zhun_btn" style="margin-left: 20px;background-color: #333;" @click="goSearch">搜索</button>
											<button class="zhun_btn" style="margin-left: 20px;color: #333;background-color: #fff;border: solid 1px #333;" @click="reset()">
												重置
											</button>
										</div>
									</li>
								</div>
								<div v-show="isTab === 1">
									<li class=" flex zhong">
										<div class="tba_dl flex zhong">
											<label>选考科目：</label>
											<div class="tba_input">
												<!-- <el-select
													v-model="collegePreferredSubject"
													@change="handleCollegePreferredSubjectChange"
													multiple
													collapse-tags
													placeholder="请选择首选科目"
												>
													<el-option v-for="item in oneOptions" :key="item" :label="item" :value="item"></el-option>
												</el-select> -->
												<el-select
													v-model="collegeRequirementsSubjects"
													@change="handleCollegeRequirementsSubjectsChange"
													multiple
													collapse-tags
													placeholder="请选择选考科目"
												>
													<el-option v-for="item in twoOptions" :key="item" :label="item" :value="item"></el-option>
												</el-select>
											</div>
										</div>
										<div class="tba_dl flex zhong">
											<label>批次选择：</label>
											<div class="tba_input">
												<el-select v-model="ppcvalue" placeholder="请选择批次">
													<el-option v-for="item in BBBatchList" :key="item" :label="item" :value="item"></el-option>
												</el-select>
											</div>
										</div>
										<div class="tba_dl flex zhong">
											<label>院校名称：</label>
											<!-- <div class="tba_input">
											<el-input v-model="collegeModel.searchCollegesName" placeholder="请输入院校名称">
											</el-input>
										</div> -->
											<div class="tba_input" style="position: relative;">
												<!-- @input="querySearchYx"
													@blur="queryYx" -->
												<el-input placeholder="请输入院校名称" v-model="collegeModel.searchCollegesName"></el-input>
												<!-- <div class="pt_yuan"
													v-show="serchYXList && serchYXList.length > 0 && YXNameListPop">
													<ul>
														<li v-for="(item, index) in serchYXList" :key="index"
															@click="handleSelectYX(item)">
															<span v-html="item.CollegesName"></span>
														</li>
													</ul>
												</div> -->
											</div>
										</div>
										<div class="tba_dl flex zhong">
											<button class="zhun_btn" style="margin-left: 20px;background-color: #333;" @click="goSearch">搜索</button>
											<button class="zhun_btn" style="margin-left: 20px;color: #333;background-color: #fff;border: solid 1px #333;" @click="reset(1)">
												重置
											</button>
										</div>
									</li>
								</div>

								<li>
									<!-- 22-02-14 -->
									<div class="ptyi_xiang">
										<ul>
											<li class="flex float">
												<div class="ptpyx_h6">院校属地</div>
												<div class="ptpyx_you flex wrap">
													<p :class="item.isSelect ? 'on' : ''" @click="onYuanShua(item)" v-for="(item, index) in yuanShuList" :key="index">
														{{ item.name }}
													</p>
												</div>
											</li>
											<li class="flex float">
												<div class="ptpyx_h6">院校类型</div>
												<div class="ptpyx_you flex wrap">
													<p :class="item.isSelect ? 'on' : ''" @click="onYuanShub(item)" v-for="(item, index) in yuanShubList" :key="index">
														{{ item.name }}
													</p>
												</div>
											</li>
											<li class="flex float">
												<div class="ptpyx_h6">院校特色</div>
												<div class="ptpyx_you flex wrap">
													<p :class="item.isSelect ? 'on' : ''" @click="onYuanShuc(item)" v-for="(item, index) in yuanShucList" :key="index">
														{{ item.name }}
													</p>
												</div>
											</li>
											<li class="flex float">
												<div class="ptpyx_h6">院校类别</div>
												<div class="ptpyx_you flex wrap">
													<p :class="item.isSelect ? 'on' : ''" @click="onYuanShud(item)" v-for="(item, index) in yuanShudList" :key="index">
														{{ item.name }}
													</p>
												</div>
											</li>
										</ul>
									</div>
								</li>
								<li class=" flex zhong float" style="padding-top: 15px;">
									<div class="flex" v-show="isTab === 0">
										<button class="zhun_btn" :class="majorModel.isMajorNames ? 'on' : ''" @click="handleMajorName">我的意向专业</button>
										<button class="zhun_btn" :class="majorModel.isCollegesNames ? 'on' : ''" @click="handleCollegesName">我的意向院校</button>
										<button class="zhun_btn" :class="majorModel.isCollegesAreas ? 'on' : ''" @click="handleCollegesArea">我的意向省市</button>
									</div>
									<div class="flex" v-show="isTab === 1">
										<button class="zhun_btn" :class="collegeModel.isMajorNames ? 'on' : ''" @click="handleMajorName">我的意向专业</button>
										<button class="zhun_btn" :class="collegeModel.isCollegesNames ? 'on' : ''" @click="handleCollegesName">我的意向院校</button>
										<button class="zhun_btn" :class="collegeModel.isCollegesAreas ? 'on' : ''" @click="handleCollegesArea">我的意向省市</button>
									</div>
									<div class="flex">
										<button class="zhun_btn" @click="isPop = true">分数范围</button>
										<!-- <button class="zhun_btn" @click="babilityPop = true">概率范围</button> -->
										<!-- <button class="zhun_btn" @click="save">保存</button> -->
										<button class="zhun_btn" @click="selectAll">全选</button>
										<button class="zhun_btn" @click="resetCondition">刷新页面</button>
										<button class="zhun_btn" @click="goPrev">上一步</button>
										<button class="zhun_btn" @click="save()">保存</button>
										<!-- @click="goVolunteerTable"  -->
										<!-- <button class="zhun_btn" @click="goVolunteerTable">我的志愿表</button> -->
									</div>
								</li>
							</ul>
						</div>
						<div class="state-type flex zhong">
							<p :class="{ 'on-type': isTab === 0 ? majorModel.CWBType === 1 : collegeModel.CWBType === 1 }" @click="selectCwb(1)">
								冲({{ isTab === 0 ? cwb1.sco1 : cwb2.sco1 }})
							</p>
							<p @click="selectCwb(2)" :class="{ 'on-type': isTab === 0 ? majorModel.CWBType === 2 : collegeModel.CWBType === 2 }">
								稳({{ isTab === 0 ? cwb1.sco2 : cwb2.sco2 }})
							</p>
							<p @click="selectCwb(3)" :class="{ 'on-type': isTab === 0 ? majorModel.CWBType === 3 : collegeModel.CWBType === 3 }">
								保({{ isTab === 0 ? cwb1.sco3 : cwb2.sco3 }})
							</p>
						</div>
					</div>
				</div>

				<!-- 4.24表格 -->
				<div class="centerWidth tb_padding" style="width: 1400px;padding-top: 0;">
					<div id="pageContainer" ref="pageContainer" class="tbc_tabel" :class="isTab == 0 ? 'active' : ''">
						<article>
							<div class="pptbiao">
								<!-- 01 -->
								<div class="ppthead flex">
									<div class="ppt_hli">
										<div class="ppt_hdd" style="width: 50px;">
											<p>{{ columnName.RateStr || '录取概率' }}</p>
										</div>
									</div>
									<div class="ppt_hli">
										<div class="ppt_hdd" style="width: 50px;">
											<p>{{ columnName.PositionStr || '志愿位置' }}</p>
										</div>
									</div>
									<div class="ppt_hli">
										<div class="ppt_hdd" style="width: 150px;">
											<p>{{ columnName.CollegesNameStr || '院校名称' }}</p>
										</div>
									</div>
									<div class="ppt_hli">
										<div class="ppt_hdd" style="width: 60px;">
											<p>{{ columnName.CollegesAreaStr || '院校地区' }}</p>
										</div>
									</div>
									<div class="ppt_hli">
										<div class="ppt_hdd" style="width: 50px;">
											<p v-if="isTab === 0">{{ columnName.MajorCodeStr || '专业代码' }}</p>
										</div>
									</div>
									<div class="ppt_hli">
										<div class="ppt_hdd" style="width: 207px;">
											<p>{{ columnName.MajorNameStr || '专业名称' }}</p>
										</div>
									</div>
									<div class="ppt_hli">
										<div class="ppt_hdd" style="width: 80px;white-space: nowrap;">
											<p v-if="isTab === 0">{{ columnName.EducationalStr || '学制/学费' }}</p>
										</div>
									</div>
									<div class="ppt_hli ppt_hlib">
										<div class="ppt_hdd" style="width: 80px;">
											<p>{{ columnName.NewPlanStr || '计划' }}</p>
										</div>
										<div class="ppt_hdd ppt_hdda">
											<p>{{ isTab === 0 ? columnName.Year : columnName.CollegeYear || '' }}</p>
										</div>
									</div>
									<div class="ppt_hli ppt_hlib">
										<div class="ppt_hdd" style="width: 297px;">
											<p>{{ columnName.YearsDateStr || '历年数据' }}</p>
										</div>
										<div class="flex ppt_hddb">
											<div class="ppt_hdd ppt_hdda">
												<p>{{ isTab === 0 ? columnName.Year1 : columnName.CollegeYear1 || `${currentYear - 1}` }}</p>
											</div>
											<div class="ppt_hdd ppt_hdda">
												<p>{{ isTab === 0 ? columnName.Year2 : columnName.CollegeYear2 || `${currentYear - 2}` }}</p>
											</div>
											<div class="ppt_hdd ppt_hdda">
												<p>{{ isTab === 0 ? columnName.Year3 : columnName.CollegeYear3 || `${currentYear - 3}` }}</p>
											</div>
										</div>
									</div>
									<div class="ppt_hli">
										<div class="ppt_hdd" style="width:80px;">
											<p>{{ columnName.BatchStr || '批次' }}</p>
										</div>
									</div>
									<div class="ppt_hli">
										<div class="ppt_hdd" style="width: 80px;">
											<p>{{ columnName.RequirementsSubjectsStr || '选考科目' }}</p>
										</div>
									</div>
									<div class="ppt_hli">
										<div class="ppt_hdd" style="width: 80px;">
											<p>{{ columnName.MajorGroupStr || '专业组' }}</p>
										</div>
									</div>
									<div class="ppt_hli">
										<div class="ppt_hdd" style="width: 80px;"><p>添加</p></div>
									</div>
								</div>
								<!-- 02 -->
								<div class="pptnei_box" :class="isTab == 0 ? 'lanse' : ''" v-if="isTab === 0 ? !ANoData : !BNoData">
									<ul v-if="isTab === 0">
										<li class="flex" v-for="(item, index) in majorList" :key="index">
											<div class="pptnei_li" style="width: 50px;">
												<div class="pptnei_view">
													<p v-if="!item.isPop">{{ item.Rate }}</p>
													<p v-if="item.isPop">新增</p>
												</div>
											</div>
											<div class="pptnei_li" style="width: 50px;">
												<div>
													<p style="color: #fa4237;" v-if="item.Position === '冲'">{{ item.Position }}</p>
													<p style="color: #f3af3b;" v-else-if="item.Position === '稳'">{{ item.Position }}</p>
													<p style="color: #42ab3f;" v-else-if="item.Position === '保'">{{ item.Position }}</p>
												</div>
											</div>
											<div class="pptnei_li" style="width: 150px;">
												<div class="pptnei_view">
													<div class="name_div ptname_div " style="width: 100%;">
														<div class="flex zhong">
															<p
																class="shl"
																style="max-width: calc(100% - 25px);cursor: pointer;"
																:style="item.IsCollegesNames ? 'color: #fa4237;' : ''"
																:class="{ 'red-text': item.IsCollegesNames }"
																@click="xueTo(item)"
															>
																{{ item.CollegesName }}
															</p>
															<el-tooltip class="item" effect="dark" placement="bottom" :content="item.CollegesName">
																<img src="../../../image/shkl.png" style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
															</el-tooltip>
														</div>
														<p>院校代码：{{ item.CollegesCode }}</p>
														<p>院校类别：{{ item.CollegesType }}</p>
														<p>院校类型：{{ item.CollegesMold }}</p>
														<p>特色：{{ item.Characte }}</p>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 60px;">
												<div class="pptnei_view">
													<p style="color: #000 !important;text-align:center !important;" :style="item.IsCollegesAreas ? 'color: #fa4237;' : ''">
														{{ item.CollegesArea }}
													</p>
												</div>
											</div>
											<div class="pptnei_li" style="width: 50px;">
												<div class="pptnei_view">
													<p style="color: #000 !important;text-align:center !important;">{{ item.MajorCode }}</p>
												</div>
											</div>
											<div class="pptnei_li" style="width: 207px;">
												<div class="pptnei_view">
													<div class="name_div ">
														<div class="flexCenter">
															<p
																class="shl"
																style="max-width: calc(100% - 25px);cursor: pointer;"
																:style="item.IsMajorNames ? 'color: #fa4237;' : ''"
																@click="zhunYeye(item)"
															>
																{{ item.MajorName | shortName }}
															</p>
															<el-tooltip class="item" effect="dark" placement="bottom" :content="item.MajorName">
																<img src="../../../image/shkl.png" style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
															</el-tooltip>
														</div>
													</div>
													<!-- <div class="ptsee" @click="GetCollege(item)">查看专业</div> -->
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<div class="name_div ">
														<p style="color: #000  !important;text-align:center !important;">
															{{ item.Educational || '' }}{{ item.Tuition ? '/' + item.Tuition : '' }}
														</p>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<div class="name_div ">
														<p style="color: #000  !important;text-align:center !important;">{{ item.NewPlan || '' }}</p>
													</div>
												</div>
											</div>
											<div class="pptnei_li pptnei_liab" style="width: 297px;">
												<div class="pptnei_view  flex" style="width: 100%;">
													<div class="pptnei_fen">
														<div class="name_div " v-if="item.isYears1 && !item.isPop">
															<p>计划：{{ item.YearsDate1.NewPlan || '' }}</p>
															<!-- <p>平均分：{{ item.YearsDate1.Average || '' }}</p> -->
															<p>最低分：{{ item.YearsDate1.LowestScore || '' }}</p>
															<p>最低位次：{{ item.YearsDate1.LowestOrder || '' }}</p>
														</div>
														<div class="pptnei_li" style="height: 100%;" v-if="item.isPop">
															<div class="pptnei_view"><p>未招生</p></div>
														</div>
													</div>
													<div class="pptnei_fen">
														<div class="name_div " v-if="item.YearsDate2 && item.YearsDate2.LowestScore">
															<p>计划：{{ item.YearsDate2.NewPlan || '' }}</p>
															<!-- <p>平均分：{{ item.YearsDate2.Average || '' }}</p> -->
															<p>最低分：{{ item.YearsDate2.LowestScore || '' }}</p>
															<p>最低位次：{{ item.YearsDate2.LowestOrder || '' }}</p>
														</div>
														<div class="pptnei_li" style="height: 100%;" v-if="(item.YearsDate2 && !item.YearsDate2.LowestScore) || !item.YearsDate2">
															<div class="pptnei_view"><p>未招生</p></div>
														</div>
													</div>
													<div class="pptnei_fen">
														<div class="name_div " v-if="item.YearsDate3 && item.YearsDate3.LowestScore">
															<p>计划：{{ item.YearsDate3.NewPlan || '' }}</p>
															<!-- <p>平均分：{{ item.YearsDate3.Average || '' }}</p> -->
															<p>最低分：{{ item.YearsDate3.LowestScore || '' }}</p>
															<p>最低位次：{{ item.YearsDate3.LowestOrder || '' }}</p>
														</div>
														<div class="pptnei_li" style="height: 100%;" v-if="(item.YearsDate3 && !item.YearsDate3.LowestScore) || !item.YearsDate3">
															<div class="pptnei_view"><p>未招生</p></div>
														</div>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<div class="name_div ">
														<p style="color: #000 !important;text-align:center !important;">{{ item.AdmissionBatch }}</p>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<div class="name_div ">
														<p style="color: #000 !important;text-align:center !important;">{{ item.RequirementsSubjects }}</p>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<p><a target="_blank" style="text-align:center !important;">{{ item.Average }}</a></p>
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<div class="flex zhong center" style="flex-direction: column;" @click="handleSelectedChange(item)">
														<span class="show-colloge-major">{{ item.selected ? '已选择' : '选择' }}</span>
														<!-- <input type="checkbox" name="add" /> -->
													</div>
												</div>
											</div>
										</li>
										<div class="ptend_gao" v-if="AisLoading">
											<div class=" ptend_div flexCenter" style="flex-direction: row;padding:15px 0;">
												<!-- <img src="../../../image/log.gif"
													style="width: 20px;height: 20px;margin-right: 12px; margin: 0;"
													v-if="ALoading" /> -->
												<!-- <span style="margin-top: 0;">加载完成</span> -->
												<img src="../../../image/log.gif" style="width: 20px;height: 20px;margin-right: 12px; margin: 0;" v-if="ALoading" />
												<span style="margin-top: 0;">{{ ALoading ? '加载中' : '加载已完成' }}</span>
											</div>
										</div>
									</ul>
									<ul v-if="isTab === 1">
										<li class="flex" v-for="(item, index) in collegeList" :key="index">
											<div class="pptnei_li" style="width: 50px;">
												<div class="pptnei_view">
													<p v-if="!item.isPop">{{ item.Rate }}</p>
													<p v-if="item.isPop">新增</p>
												</div>
											</div>
											<div class="pptnei_li" style="width: 50px;">
												<div>
													<p style="color: #fa4237;" v-if="item.Position === '冲'">{{ item.Position }}</p>
													<p style="color: #f3af3b;" v-else-if="item.Position === '稳'">{{ item.Position }}</p>
													<p style="color: #42ab3f;" v-else-if="item.Position === '保'">{{ item.Position }}</p>
												</div>
											</div>
											<div class="pptnei_li" style="width: 150px;">
												<div class="pptnei_view">
													<div class="name_div ptname_div " style="width: 100%;">
														<div class="flex zhong">
															<p
																style="width: calc(100% - 25px);cursor: pointer;"
																:style="item.IsCollegesNames ? 'color: #fa4237;' : ''"
																:class="{ 'red-text': item.IsCollegesNames }"
																@click="xueTo(item)"
															>
																{{ item.CollegesName }}
															</p>
															<el-tooltip class="item" effect="dark" placement="bottom" :content="item.CollegesName">
																<img src="../../../image/shkl.png" style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
															</el-tooltip>
														</div>
														<p>院校代码：{{ item.CollegesCode }}</p>
														<p>院校类别：{{ item.CollegesType }}</p>
														<p>院校类型：{{ item.CollegesMold }}</p>
														<p>特色：{{ item.Characte }}</p>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 60px;">
												<div class="pptnei_view">
													<p style="color: #000 !important; text-align:center !important;" :style="item.IsCollegesAreas ? 'color: #fa4237;' : ''">
														{{ item.CollegesArea }}
													</p>
												</div>
											</div>
											<div class="pptnei_li" style="width: 50px;">
												<div class="pptnei_view">
													<p style="color: #000 !important; text-align:center !important;">{{ item.MajorCode }}</p>
												</div>
											</div>
											<div class="pptnei_li" style="width: 207px;">
												<div class="pptnei_view">
													<div class="name_div ">
														<div class="flex zhong">
															<p style="width: calc(100% - 25px);cursor: pointer;">{{ item.MajorName | shortName }}</p>
															<!-- <el-tooltip class="item" effect="dark" placement="bottom">
																<img src="../../../image/shkl.png"
																	style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
															</el-tooltip> -->
														</div>
													</div>
													<div class="ptsee" @click="showCollegeMajor(item.Id,true)" 
													:style=" item.IsMajorNames?'color:#ff0000':''">查看专业</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<div class="name_div ">
														<p style="color: #000  !important; text-align:center !important;">
															{{ item.Educational || '' }}{{ item.Tuition ? '/' + item.Tuition : '' }}
														</p>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<div class="name_div ">
														<p style="color: #000  !important; text-align:center !important;">{{ item.NewPlan || '' }}</p>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 297px;">
												<div class="pptnei_view flex" style="width: 100%;">
													<div class="pptnei_fen">
														<div class="name_div " v-if="item.isYears1 && !item.isPop">
															<!-- <p>平均分：{{ item.YearsDate1.Average || '' }}</p> -->
															<p>最低分：{{ item.YearsDate1.LowestScore || '' }}</p>
															<p>最低位次：{{ item.YearsDate1.LowestOrder || '' }}</p>
														</div>
														<div class="pptnei_li" style="height: 100%;" v-if="item.isPop">
															<div class="pptnei_view"><p>未招生</p></div>
														</div>
													</div>
													<div class="pptnei_fen">
														<div class="name_div " v-if="item.YearsDate2 && item.YearsDate2.LowestScore">
															<!-- <p>平均分：{{ item.YearsDate2.Average || '' }}</p> -->
															<p>最低分：{{ item.YearsDate2.LowestScore || '' }}</p>
															<p>最低位次：{{ item.YearsDate2.LowestOrder || '' }}</p>
														</div>
														<div class="pptnei_li" style="height: 100%;" v-if="(item.YearsDate2 && !item.YearsDate2.LowestScore) || !item.YearsDate2">
															<div class="pptnei_view"><p>未招生</p></div>
														</div>
													</div>
													<div class="pptnei_fen">
														<div class="name_div " v-if="item.YearsDate3 && item.YearsDate3.LowestScore">
															<!-- <p>平均分：{{ item.YearsDate3.Average || '' }}</p> -->
															<p>最低分：{{ item.YearsDate3.LowestScore || '' }}</p>
															<p>最低位次：{{ item.YearsDate3.LowestOrder || '' }}</p>
														</div>
														<div class="pptnei_li" style="height: 100%;" v-if="(item.YearsDate3 && !item.YearsDate3.LowestScore) || !item.YearsDate3">
															<div class="pptnei_view"><p>未招生</p></div>
														</div>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<div class="name_div ">
														<p style="color: #000 !important; text-align:center !important;">{{ item.AdmissionBatch }}</p>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<div class="name_div ">
														<p style="color: #000 !important; text-align:center !important;">{{ item.RequirementsSubjects }}</p>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<div class="name_div ">
														<p style="color: #000 !important; text-align:center !important;">{{ item.Average }}</p>
													</div>
												</div>
											</div>
											<div class="pptnei_li" style="width: 80px;">
												<div class="pptnei_view">
													<div class="flex zhong center" style="flex-direction: column;" @click="showCollegeMajor(item.Id)">
														<span class="show-colloge-major">{{ item.selected ? '已选择' : '选择' }}</span>
														<!-- <input type="checkbox" name="add" /> -->
													</div>
												</div>
											</div>
										</li>
										<div class="ptend_gao" v-if="BisLoading">
											<div class=" ptend_div flexCenter" style="flex-direction: row;padding:15px 0;">
												<img src="../../../image/log.gif" style="width: 20px;height: 20px;margin-right: 12px; margin: 0;" v-if="BLoading" />
												<span style="margin-top: 0;">{{ BLoading ? '加载中' : '加载已完成' }}</span>
											</div>
										</div>
									</ul>
								</div>
								<div class="ptend_gao" v-if="isTab === 0 ? ANoData : BNoData">
									<div class=" ptend_div">
										<img src="../../../image/empty.png" />
										<p>暂无数据</p>
									</div>
								</div>
							</div>
						</article>
					</div>
				</div>

				<!-- <div class="centerWidth tb_padding" style="width: 1400px;padding-top: 0;">
				<div id="pageContainer" ref="pageContainer" class="tbc_tabel" :class="isTab == 1 ? 'active' : ''">
					<article>
						<el-table :data="isTab === 0 ? majorList : collegeList" highlight-current-row border
							row-key="id" style="width: 100%"
							v-loading="(loading1 && majorModel.page === 1) || (loading2 && collegeModel.page === 1)"
							element-loading-background="rgba(255, 255, 255, 0.2)">
							<el-table-column prop="Rate" :label="columnName.RateStr || '录取概率'" width="50">
							</el-table-column>
							<el-table-column :label="columnName.PositionStr || '志愿位置'" width="50">
								<template slot-scope="scope">
									<div>
										<p style="color: #fa4237;" v-if="scope.row.Position === '冲'">冲</p>
										<p style="color: #f3af3b;" v-else-if="scope.row.Position === '稳'">稳</p>
										<p style="color: #42ab3f;" v-else-if="scope.row.Position === '保'">保</p>
									</div>
								</template>
							</el-table-column>
							<el-table-column :label="columnName.CollegesNameStr || '院校名称'" width="200">
								<template slot-scope="scope">
									<div class="name_div ">
										<div class="flex zhong"> -->
				<!-- 22.2.15  @click="xueTo(scope.row.CollegesName)" -->
				<!-- <p style="width: calc(100% - 25px);cursor: pointer;color: #fa4237;"
												:class="{ 'red-text': scope.row.IsCollegesNames }"
												@click="xueTo(scope.row)">
												{{ scope.row.CollegesName | shortName }}
											</p>
											<el-tooltip class="item" effect="dark" :content="scope.row.CollegesName"
												placement="bottom">
												<img src="../../../image/shkl.png"
													style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
											</el-tooltip>
										</div>
										<p>院校代码：{{ scope.row.CollegesCode }}</p>
										<p>院校类别：{{ scope.row.CollegesType }}</p>
										<p>院校类型：{{ scope.row.CollegesMold }}</p>
										<p>特色：{{ scope.row.Characte }}</p>
									</div>
								</template>
							</el-table-column>
							<el-table-column :label="columnName.CollegesAreaStr || '院校地区'" width="60">
								<template slot-scope="scope">
									<span :class="{ 'red-text': scope.row.IsCollegesAreas }"
										@click="xueTo()">{{ scope.row.CollegesArea }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="MajorCode" :label="columnName.MajorCodeStr || '专业代码'" width="50">
							</el-table-column>
							<el-table-column :label="columnName.MajorNameStr || '专业名称'" width="177">
								<template slot-scope="scope">
									<div class="name_div " v-if="isTab === 0">
										<div class="flex zhong"> -->
				<!-- 22.02.15 @click="showMajorDetail(scope)" -->
				<!-- <p style="width: calc(100% - 25px);cursor: pointer;color: #fa4237;"
												:class="{ 'red-text': scope.row.IsMajorNames }"
												@click="zhunYe(scope.row)">
												{{ scope.row.MajorName | shortName }}
											</p>
											<el-tooltip class="item" effect="dark" :content="scope.row.MajorName"
												placement="bottom">
												<img src="../../../image/shkl.png"
													style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
											</el-tooltip>
										</div>
									</div>
									<div v-if="isTab === 1" class="ptsee" @click="GetCollege(scope.row)">查看专业</div>
								</template>
							</el-table-column>
							<el-table-column :label="columnName.EducationalStr || '学制/学费'" width="100">
								<template slot-scope="scope">
									{{ `${scope.row.Educational || ''}/${scope.row.Tuition || ''}` }}
								</template>
							</el-table-column>
							<el-table-column :label="columnName.NewPlanStr || '计划'">
								<el-table-column prop="NewPlan"
									:label="(isTab === 0 ? columnName.Year : columnName.CollegeYear) || ''" width="52">
								</el-table-column>
							</el-table-column>
							<el-table-column :label="columnName.YearsDateStr || '历年数据'">
								<el-table-column prop="yeara"
									:label="(isTab === 0 ? columnName.Year1 : columnName.CollegeYear1) || `${currentYear - 1}`"
									width="80">
									<template slot-scope="scope" v-if="scope.row.YearsDate1">
										<div class="name_div ">
											<p>计划：{{ scope.row.YearsDate1.NewPlan }}</p>
											<p>平均分：{{ scope.row.YearsDate1.Average }}</p>
											<p>最低分：{{ scope.row.YearsDate1.LowestScore }}</p>
											<p>最低位次：{{ scope.row.YearsDate1.LowestOrder }}</p>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="yearb"
									:label="(isTab === 0 ? columnName.Year2 : columnName.CollegeYear2) || `${currentYear - 2}`"
									width="80">
									<template slot-scope="scope" v-if="scope.row.YearsDate2">
										<div class="name_div ">
											<p>计划：{{ scope.row.YearsDate2.NewPlan }}</p>
											<p>平均分：{{ scope.row.YearsDate2.Average }}</p>
											<p>最低分：{{ scope.row.YearsDate2.LowestScore }}</p>
											<p>最低位次：{{ scope.row.YearsDate2.LowestOrder }}</p>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="yearc"
									:label="(isTab === 0 ? columnName.Year3 : columnName.CollegeYear3) || `${currentYear - 3}`"
									width="80">
									<template slot-scope="scope" v-if="scope.row.YearsDate3">
										<div class="name_div ">
											<p>计划：{{ scope.row.YearsDate3.NewPlan }}</p>
											<p>平均分：{{ scope.row.YearsDate3.Average }}</p>
											<p>最低分：{{ scope.row.YearsDate3.LowestScore }}</p>
											<p>最低位次：{{ scope.row.YearsDate3.LowestOrder }}</p>
										</div>
									</template>
								</el-table-column>
							</el-table-column>
							<el-table-column prop="PreferredSubject" :label="columnName.PreferredSubjectStr || '首选科目'"
								width="110"></el-table-column>
							<el-table-column prop="RequirementsSubjects"
								:label="columnName.RequirementsSubjectsStr || '选考科目'" width="110"></el-table-column>
							<el-table-column :label="columnName.SolutionStr || '招生章程'" width="110">
								<template slot-scope="scope">
									<p v-if="scope.row.Solution" @click="goSolution(scope.row.Solution)"
										class="pointer">章程</p>
									<p v-else>暂无</p>
								</template>
							</el-table-column>
							<el-table-column label="添加" width="50 " prop="Id">
								<template slot-scope="scope">
									<div class="flex zhong center" style="flex-direction: column;">
										<span class="show-colloge-major" v-if="isTab === 1"
											@click="showCollegeMajor(scope.row.Id)">
											{{ scope.row.selected ? '已选择' : '选择' }}
										</span>
										<input type="checkbox" name="add" v-model="scope.row.selected"
											@change="handleSelectedChange(scope.row.Id, scope.row.selected)" v-else />
									</div>
								</template>
							</el-table-column> -->
				<!-- <el-table-column label="添加" width="70 " prop="Id">
								<template slot-scope="scope">
									<div class="pt_add">
										<p v-if="!scope.row.selected" @click="handleSelectedChange(scope.row.Id, scope.row.selected)">选择</p>
										<p v-else class="pt_add_b" style="line-height: initial;" @click="handleSelectedChange(scope.row.Id, scope.row.selected)">取消选择</p>
									</div>
								</template> -->
				<!-- 22.2.15
                                   <template slot-scope="scope">
                                 <div class="flex zhong center" style="flex-direction: column;">
                                        <input type="checkbox" name="add" v-model="scope.row.selected" @change="handleSelectedChange(scope.row.Id, scope.row.selected)" />
                                        <span class="show-colloge-major" v-if="isTab === 1" @click="showCollegeMajor(scope.row.Id)">专业</span></div></template>-->
				<!-- </el-table-column> -->
				<!-- <el-table-column :label="columnName.UserAttentionStr || '关注'" width="55">
                            <template slot-scope="scope">
                                <img
                                    :src="scope.row.UserAttention ? require('../../../image/gz_aa.png') : require('../../../image/gz_a.png')"
                                    class="scImg"
                                    style="zoom: 0.7;"
                                    @click="attentItem(scope)"
                                />
                            </template>
                        </el-table-column> -->
				<!-- 	</el-table>
						<div v-loading="(loading1 && majorModel.page > 1) || (loading2 && collegeModel.page > 1)"
							element-loading-background="rgba(255, 255, 255, 0)"></div>
					</article> -->
				<!-- </div> -->
				<!-- </div> -->
				<!--  <div class=" flex zhongc center">
                <button class="gaokao-btn" style="margin: 50px 20px;" >上一步</button>
                <button class="gaokao-btn"  style="margin: 50px 20px;">下一步</button>
            </div> -->
				<!-- <div class="jiazai flexCenter" @click="loadMore()">
				<el-button type="primary" :loading="true" style="cursor: pointer;" v-if="!loadMoreing">加载更多
				</el-button>
			</div> -->
			</div>

			<!-- -++ -->
			<div class="pt_you">
				<div class="pt_you_kuan" v-if="isPopup">
					<div class="pt_youa" style="cursor: pointer;" @click="RefullIsPopup">
						{{ ZiTotal }}
						<span>已添加志愿</span>
					</div>
					<div class="pt_youb" @click="save()">保存</div>
				</div>
				<div class="pt_you_kuan" v-else>
					<div class="pt_youa" style="cursor: pointer;" @click="QuitIsPopup">
						{{ ZiTotal }}
						<span>关闭志愿</span>
					</div>
					<p>{{ chongTotal }}</p>
					<p class="yellow">{{ WenTotal }}</p>
					<p class="green">{{ BaoTotal }}</p>
				</div>
				<!-- 弹窗 -->
				<aside class="zhi_popup" v-if="!isPopup">
					<div class="zhi_imga" v-if="isSetChi">
						<div class="zhi_kedu">
							<div class="kedu_dd" :class="item.type == 1 ? '' : item.type == 2 ? 'yellow' : 'green'" v-for="(item, index) in keduList" :key="index">
								<div class="pta zhan" v-for="(it, ind) in item.list" :key="ind">
									<p>{{ it.value }}</p>
									<span class="ke_li "></span>
									<span></span>
									<span></span>
									<span></span>
									<span></span>
									<span></span>
								</div>
							</div>
						</div>
					</div>

					<div class="zhi_gao" style="height: 100%;" :style="{ 'margin-left': isSetChi ? '53px' : '' }">
						<!-- <div class="zhi_fg flex zhong " style="cursor: pointer;" @click="isSetChiClick()">
							志愿梯度设置
							<img src="../../../image/aset.png" :style="{ transform: isSetChi ? 'rotate(180deg)' : '' }" />
						</div> -->
						<div class="zhi_h">
							<!-- 01 -->
							<!-- <span>请先输入数据后才会显示刻度</span> -->
							<div class="zhi_head" v-if="isSetChiDiv">
								<div class="zhi_head_li flex zhong">
									<h6>冲</h6>
									<div class="zhi_head_a"><el-input v-model="atiValue" type="number" placeholder="分数" @change="valueChage($event, 1)"></el-input></div>
									<div class="zhi_head_a" style="padding-left: 30px;">
										<el-input v-model="ctiValue" type="number" placeholder="数量" @change="NumChage($event, 1)"></el-input>
									</div>
								</div>
								<div class="zhi_head_li flex zhong" style="margin-top: 20px;">
									<h6 style="color: #f3af3b;">稳</h6>
									<div class="zhi_head_a"><el-input v-model="dtiValue" type="number" placeholder="分数" @change="valueChage($event, 2)"></el-input></div>
									<div class="zhi_head_a" style="padding-left: 30px;">
										<el-input v-model="ftiValue" type="number" placeholder="数量" @change="NumChage($event, 2)"></el-input>
									</div>
								</div>
								<div class="zhi_head_li flex zhong" style="margin-top: 20px;">
									<h6 style="color: #42ab3f;">保</h6>
									<div class="zhi_head_a">
										<el-input v-model="gtiValue" type="number" placeholder="分数" @change="valueChage($event, 3)"></el-input>
										<el-input v-model="htiValue" type="number" placeholder="分数" style="margin-top: 20px;" @change="valueChage($event, 4)"></el-input>
									</div>
									<div class="zhi_head_a" style="padding-left: 30px;">
										<el-input v-model="jtiValue" type="number" placeholder="数量" @change="NumChage($event, 3)"></el-input>
									</div>
								</div>
							</div>
							<!-- 02 -->
							<div class="zhi_list">
								<ul>
									<li v-for="(item, index) in pouplist" :key="index">
										<div class="zhi_lihead flexFloat">
											<div class="zhi_lileft flex zhong" :class="item.major.Position == '稳' ? 'orange' : item.major.Position == '保' ? 'green' : ''">
												<h6>
													<i>{{ index + 1 }}</i>
													{{ item.major.CollegesName }}
												</h6>
												<span>{{ item.major.Position }}</span>
											</div>
											<div class="zhi_liyou flexFloat">
												<div class="zhi_btn flex">
													<p v-if="index != 0" @click="goUpupup(item, index)">上移</p>
													<p v-if="index + 1 != pouplist.length" @click="goDown(item, index)">下移</p>
												</div>
												<img src="../../../image/adel.png" class="zhi_del_img" @click="deletePoup(item, index, item.Type)" />
											</div>
										</div>
										<div v-if="item.Type == 1">
											<div class="xhi_lidiv flexFloat" v-for="(childItem, childIndex) in item.collegeList" :key="childIndex">
												<p class="shl">{{ childItem.No || childIndex + 1 }}、{{ childItem.Name }}</p>
												<div class="flexFloat xhi_libox">
													<p class="flex" v-if="childItem.Remarks!='新增'&&childItem.Year1&&childItem.Year1.LowestScore">
														<span>{{ childItem.Position }}</span>
														<span>{{ childItem.LowestScore }}</span>
														<span>{{ childItem.LowestOrder }}</span>
													</p>
													<p class="flex" v-else>
														<span>{{ childItem.Position }}</span>
														<span>未招生</span>
													</p>
													<img src="../../../image/adel.png" class="zhi_del_img" @click="deleteCollege(childItem, index, childIndex)" />
												</div>
											</div>
										</div>
										<div v-if="item.Type == 2">
											<div class="xhi_lidiv flexFloat" v-for="(childItem, childIndex) in 1" :key="childIndex">
												<p class="shl">{{ childIndex + 1 }}、{{ item.major.MajorName }}</p>
												<div class="flexFloat xhi_libox">
													<p class="flex" v-if="item.major.Remarks!='新增'&&item.major.Year1&&item.major.Year1.LowestScore">
														<span>{{ item.major.Position }}</span>
														<span>{{ item.major.LowestScore }}</span>
														<span>{{ item.major.LowestOrder }}</span>
													</p>
													<p class="flex" v-else>
														<span>{{ item.major.Position }}</span>
														<span>未招生</span>
													</p>
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</aside>
			</div>
			<div class="pt_youc" @click="topD"><img src="../../../image/xs.png" /></div>
			<!-- 等效分 -->
			<aside class="popup flex zhong center" v-if="isPop">
				<div class="aside_pop " style="position: relative;">
					<img
						src="../../../image/vol-del-t.png"
						@click="isPop = false"
						style="display: block;width: 20px;height: 20px;position: absolute;right: 15px;top: 15px;margin: 0;z-index: 1;cursor: pointer;"
					/>
					<div class="aside_div flex zhong">
						<el-input readonly value="-150" style="width:58px;"></el-input>
						<div class="flex zhong aside_box" v-show="isTab === 0">
							<p>{{ majorScore[0] }}</p>
							<div class="block"><el-slider v-model="majorScore" range :max="scoreModel.score + 150" :min="scoreModel.score - 150"></el-slider></div>
							<p>{{ majorScore[1] }}</p>
						</div>
						<div class="flex zhong aside_box" v-show="isTab === 1">
							<p>{{ collegeScore[0] }}</p>
							<div class="block"><el-slider v-model="collegeScore" range :max="scoreModel.score + 150" :min="scoreModel.score - 150"></el-slider></div>
							<p>{{ collegeScore[1] }}</p>
						</div>
						<el-input readonly value="+150" style="width:58px;"></el-input>
					</div>
					<div class="aside_btn flex zhong center">
						<button class="zhun_btn" @click="resetScore">还原</button>
						<button class="zhun_btn" @click="handleSubmitScore">确认</button>
					</div>
				</div>
			</aside>
			<!-- //概率范围 -->
			<aside class="popup flex zhong center" v-if="babilityPop">
				<div class="aside_pop " style="position: relative;">
					<img
						src="../../../image/vol-del-t.png"
						@click="babilityPop = false"
						style="display: block;width: 20px;height: 20px;position: absolute;right: 15px;top: 15px;margin: 0;z-index: 1;cursor: pointer;"
					/>
					<div class="aside_div flex zhong">
						<el-input readonly value="1" style="width:58px;"></el-input>
						<div class="flex zhong aside_box" v-show="isTab === 0">
							<p>{{ majorbability[0] }}</p>
							<div class="block"><el-slider v-model="majorbability" range :max="99" :min="1"></el-slider></div>
							<p>{{ majorbability[1] }}</p>
						</div>
						<div class="flex zhong aside_box" v-show="isTab === 1">
							<p>{{ collegebability[0] }}</p>
							<div class="block"><el-slider v-model="collegebability" range :max="99" :min="1"></el-slider></div>
							<p>{{ collegebability[1] }}</p>
						</div>
						<el-input readonly value="99" style="width:58px;"></el-input>
					</div>
					<div class="aside_btn flex zhong center">
						<button class="zhun_btn" @click="resetbability">还原</button>
						<button class="zhun_btn" @click="handlebability">确认</button>
					</div>
				</div>
			</aside>
			<!-- 查看专业  -->
			<aside class="popup flexCenter" v-if="isSeePop">
				<div class="ptzhuanYe_bai">
					<img src="../../../image/vol-del-t.png" @click="isSeePop = false" />
					<h6>东北师范大学</h6>
					<div class="ptzhuan_gao">
						<div id="pageContainer" ref="pageContainer" class="tbc_tabel" :class="isTab == 1 ? 'active' : ''">
							<article>
								<el-table
									:data="isTab === 0 ? majorList : collegeList"
									highlight-current-row
									border
									row-key="id"
									style="width: 100%"
									max-height="380"
									v-loading="(loading1 && majorModel.page === 1) || (loading2 && collegeModel.page === 1)"
									element-loading-background="rgba(255, 255, 255, 0.2)"
								>
									<el-table-column label="添加" width="50 " prop="Id">
										<template slot-scope="scope">
											<div class="flex zhong center" style="flex-direction: column;">
												<input type="checkbox" name="add" v-model="scope.row.selected" @change="handleSelectedChange(scope.row.Id, scope.row.selected)" />
												<span class="show-colloge-major" v-if="isTab === 1" @click="showCollegeMajor(scope.row.Id)">专业</span>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="Rate" :label="columnName.RateStr || '录取概率'" width="50"></el-table-column>
									<el-table-column :label="columnName.PositionStr || '志愿位置'" width="50">
										<template slot-scope="scope">
											<div>
												<p style="color: #fa4237;" v-if="scope.row.Position === '冲'">冲</p>
												<p style="color: #f3af3b;" v-else-if="scope.row.Position === '稳'">稳</p>
												<p style="color: #42ab3f;" v-else-if="scope.row.Position === '保'">保</p>
											</div>
										</template>
									</el-table-column>
									<el-table-column :label="columnName.CollegesNameStr || '院校名称'" width="160">
										<template slot-scope="scope">
											<div class="name_div ">
												<div class="flex zhong">
													<!-- 22.2.15  @click="xueTo(scope.row.CollegesName)" -->
													<p style="width: calc(100% - 25px);cursor: pointer;color: #fa4237;" :class="{ 'red-text': scope.row.IsCollegesNames }">
														{{ scope.row.CollegesName | shortName }}
													</p>
													<el-tooltip class="item" effect="dark" :content="scope.row.CollegesName" placement="bottom">
														<img src="../../../image/shkl.png" style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
													</el-tooltip>
												</div>
												<p>院校代码：{{ scope.row.CollegesCode }}</p>
												<p>院校类别：{{ scope.row.CollegesType }}</p>
												<p>院校类型：{{ scope.row.CollegesMold }}</p>
												<p>特色：{{ scope.row.Characte }}</p>
											</div>
										</template>
									</el-table-column>
									<el-table-column :label="columnName.CollegesAreaStr || '院校地区'" width="100">
										<template slot-scope="scope">
											<span :class="{ 'red-text': scope.row.IsCollegesAreas }">{{ scope.row.CollegesArea }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="MajorCode" :label="columnName.MajorCodeStr || '专业代码'" width="50"></el-table-column>
									<el-table-column :label="columnName.MajorNameStr || '专业名称'" width="157">
										<template slot-scope="scope">
											<div class="name_div " v-if="isTab === 0">
												<div class="flex zhong">
													<!-- 22.02.15 @click="showMajorDetail(scope)" -->
													<p style="width: calc(100% - 25px);cursor: pointer;color: #fa4237;" :class="{ 'red-text': scope.row.IsMajorNames }">
														{{ scope.row.MajorName | shortName }}
													</p>
													<el-tooltip class="item" effect="dark" :content="scope.row.MajorName" placement="bottom">
														<img src="../../../image/shkl.png" style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
													</el-tooltip>
												</div>
											</div>
											<!-- <div v-if="isTab === 1" class="ptsee">查看专业</div> -->
										</template>
									</el-table-column>
									<el-table-column :label="columnName.EducationalStr || '学制/学费'" width="100">
										<template slot-scope="scope">
											{{ `${scope.row.Educational || ''}/${scope.row.Tuition || ''}` }}
										</template>
									</el-table-column>
									<el-table-column :label="columnName.NewPlanStr || '计划'">
										<el-table-column prop="NewPlan" :label="(isTab === 0 ? columnName.Year : columnName.CollegeYear) || ''" width="52"></el-table-column>
									</el-table-column>
									<el-table-column :label="columnName.YearsDateStr || '历年数据'">
										<el-table-column prop="yeara" :label="(isTab === 0 ? columnName.Year1 : columnName.CollegeYear1) || `${currentYear - 1}`" width="100">
											<template slot-scope="scope" v-if="scope.row.YearsDate1">
												<div class="name_div ">
													<p>计划：{{ scope.row.YearsDate1 ? scope.row.YearsDate1.NewPlan : '' }}</p>
													<!-- <p>平均分：{{ scope.row.YearsDate1 ? scope.row.YearsDate1.Average : '' }}</p> -->
													<p>最低分：{{ scope.row.YearsDate1 ? scope.row.YearsDate1.LowestScore : '' }}</p>
													<p>最低位次：{{ scope.row.YearsDate1 ? scope.row.YearsDate1.LowestOrder : '' }}</p>
												</div>
											</template>
										</el-table-column>
										<el-table-column prop="yearb" :label="(isTab === 0 ? columnName.Year2 : columnName.CollegeYear2) || `${currentYear - 2}`" width="100">
											<template slot-scope="scope" v-if="scope.row.YearsDate2">
												<div class="name_div ">
													<p>计划：{{ scope.row.YearsDate2 ? scope.row.YearsDate2.NewPlan : '' }}</p>
													<!-- <p>平均分：{{ scope.row.YearsDate2 ? scope.row.YearsDate2.Average : '' }}</p> -->
													<p>最低分：{{ scope.row.YearsDate2 ? scope.row.YearsDate2.LowestScore : '' }}</p>
													<p>最低位次：{{ scope.row.YearsDate2 ? scope.row.YearsDate2.LowestOrder : '' }}</p>
												</div>
											</template>
										</el-table-column>
										<el-table-column prop="yearc" :label="(isTab === 0 ? columnName.Year3 : columnName.CollegeYear3) || `${currentYear - 3}`" width="100">
											<template slot-scope="scope" v-if="scope.row.YearsDate3">
												<div class="name_div ">
													<p>计划：{{ scope.row.YearsDate3 ? scope.row.YearsDate3.NewPlan : '' }}</p>
													<!-- <p>平均分：{{ scope.row.YearsDate3 ? scope.row.YearsDate3.Average : '' }}</p> -->
													<p>最低分：{{ scope.row.YearsDate3 ? scope.row.YearsDate3.LowestScore : '' }}</p>
													<p>最低位次：{{ scope.row.YearsDate3 ? scope.row.YearsDate3.LowestOrder : '' }}</p>
												</div>
											</template>
										</el-table-column>
									</el-table-column>
									<el-table-column prop="PreferredSubject" :label="columnName.PreferredSubjectStr || '批次'" width="90"></el-table-column>
									<el-table-column prop="RequirementsSubjects" :label="columnName.RequirementsSubjectsStr || '选考科目'" width="90"></el-table-column>
									<el-table-column :label="columnName.SolutionStr || '专业组'" width="90">
										<template slot-scope="scope">
											<p v-if="scope.row.Solution" @click="goSolution(scope.row.Solution)" class="pointer">章程</p>
											<p v-else>暂无</p>
										</template>
									</el-table-column>
									<el-table-column :label="columnName.UserAttentionStr || '关注'" width="55">
										<template slot-scope="scope">
											<img
												:src="scope.row.UserAttention ? require('../../../image/gz_aa.png') : require('../../../image/gz_a.png')"
												class="scImg"
												style="zoom: 0.7;"
												@click="attentItem(scope)"
											/>
										</template>
									</el-table-column>
								</el-table>
								<div v-loading="(loading1 && majorModel.page > 1) || (loading2 && collegeModel.page > 1)" element-loading-background="rgba(255, 255, 255, 0)"></div>
							</article>
						</div>
					</div>
					<div class="ptzhuan_btn flex xend">
						<el-button @click="isSeePop = false">取消</el-button>
						<el-button type="primary">确认</el-button>
					</div>
				</div>
			</aside>

			<!-- 专业 -->
			<aside class="popup flex zhong center" v-if="isZyPop">
				<div class="aside_pop">
					<div class="aside_height">
						<ul>
							<li class="pointer" v-for="(item, index) in majorDetail" :key="index" @click="goMajorInfo(item.Id)">{{ item.Name }}</li>
						</ul>
					</div>
					<div class="aside_btn flex zhong center"><button class="zhun_btn" @click="(isZyPop = false), (majorDetail = [])">关闭</button></div>
				</div>
			</aside>
			<el-dialog width="1200px" :title="currentCollegeMajor.name" :visible.sync="collogeMajorVisible" :close-on-click-modal="false" top="50px" :show-close="true" :before-close="beforecCloseCollegeMajor">
				<college-major :list="currentCollegeMajor.list" :columnName="columnName" @showMajorDetail="showMajorDetail"></college-major>
				<span slot="footer" class="dialog-footer">
					<el-button @click="closeCollegeMajor(false)">取 消</el-button>
					<el-button type="primary" @click="closeCollegeMajor(true)">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 选择专业 22.2.14-->
			<aside class="popup flexCenter" v-if="isZhuan">
				<div class="ptzhuan_bai">
					<img src="../../../image/vol-del-t.png" @click="isZhuan = false" />
					<div class="ptzhuan_h6">选择专业</div>
					<div style="height: 400px;overflow: auto;" v-if="!ZyNoData">
						<div class="ptzhuan_list flex wrap">
							<p :title="item.Name" v-for="(item, index) in zhuanList" :key="index" @click="zhuanYeTo(item)">{{ item.Name }}</p>
						</div>
					</div>
					<div class="ptend_gao" v-else>
						<div class=" ptend_div">
							<img src="../../../image/empty.png" />
							<p>暂无数据</p>
						</div>
					</div>
				</div>
			</aside>
			<!-- ZyNoData -->
			<aside class="popup flexCenter" v-if="isXueYuan">
				<div class="ptzhuan_bai">
					<img src="../../../image/vol-del-t.png" @click="isXueYuan = false" />
					<div class="ptzhuan_h6">选择学校</div>
					<div style="height: 400px;overflow: auto;" v-if="!XiaoNoData">
						<div class="ptzhuan_list flex wrap">
							<p :title="item.Name" v-for="(item, index) in XiaoList" :key="index" @click="yuanXiaoTo(item)">{{ item.Name }}</p>
						</div>
						<!-- <el-empty description="暂无数据" ></el-empty> -->
					</div>
					<div class="ptend_gao" v-else>
						<div class=" ptend_div">
							<img src="../../../image/empty.png" />
							<p>暂无数据</p>
						</div>
					</div>
				</div>
			</aside>
		</section>
	</div>
</template>
<script>
import CollegeMajor from './CollegeMajor';

const queryModel = {
	page: 1,
	pageSize: 20,
	userId: 0,
	selectId: 0,
	isCollegesAreas: false,
	isMajorNames: false,
	isCollegesNames: false,
	preferredSubject: '',
	requirementsSubjects: '',
	searchMajorName: '',
	searchCollegesName: '',
	searchCitysCode: '',
	minScore: '',
	maxScore: '',
	CWBType: 0,
	totleScore: 0
};

const now = new Date();
export default {
	data() {
		return {
			AFrist: 1,
			BFrist: 1,
			BisLoading: false,
			BLoading: false,
			AisLoading: false,
			ALoading: false,
			XiaoNoData: false,
			ZyNoData: false,
			ANoData: false,
			BNoData: false,
			YXNameList: [],
			serchYXList: [],
			YXNameListPop: false,
			YXName: '',
			zyNameListPop: false,
			serchZyList: [],
			zyNameList: [],
			windowHeight: document.documentElement.clientHeight,
			count: 50,
			busy: false,
			isSetChiDiv: false,
			isSeePop: false,
			isSetChi: false,
			isXuan: true,
			atiValue: '',
			btiValue: '',
			ctiValue: '',
			dtiValue: '',
			etiValue: '',
			ftiValue: '',
			gtiValue: '',
			htiValue: '',
			jtiValue: '',
			isPopup: true,
			pouplist: [],
			// 22.2.15
			// 选中的专业id
			selectedMajorId: [],
			// 选中的院校
			selectedCollegeMajor: [],
			// 当前弹窗显示专业
			currentCollegeMajor: {
				id: 0,
				name: '',
				dtoStr: '',
				list: []
			},
			// 是否显示院校专业选择弹窗
			collogeMajorVisible: false,
			currentYear: now.getFullYear(),
			// 院校选择选中id
			collegeSelectedId: [],
			// 专业选择选中id
			majorSelectedId: [],
			// 院校选择等效分
			collegeScore: [-150, 150],
			// 专业选择等效分
			majorScore: [-150, 150],
			// 院校选择概率分
			collegebability: [1, 99],
			// 专业选择概率分
			majorbability: [1, 99],
			// 专业院校地区
			majorSearchCitysCode: [],
			// 院校院校地区
			collegeSearchCitysCode: [],
			// 专业首选科目
			preferredSubject: [],
			// 专业选考科目
			requirementsSubjects: [],
			// 院校首选科目
			collegePreferredSubject: [],
			// 院校选考科目
			collegeRequirementsSubjects: [],
			scoreModel: {},
			// 专业选择搜索分页条件
			majorModel: {
				...queryModel,
				userId: this.$store.state.user.userId,
				selectId: this.$parent.selectId,
				totleScore: this.$parent.totalScore
			},
			// 专业选择总页数
			majorTotalPage: 0,
			// 院校选择分页条件
			collegeModel: {
				...queryModel,
				userId: this.$store.state.user.userId,
				selectId: this.$parent.selectId,
				totleScore: this.$parent.totalScore
			},
			// 院校选择总页数
			collegeTotalPage: 0,
			columnName: {},
			isPop: false,
			babilityPop: false,
			isZyPop: false,
			isTab: 0,
			oneOptions: [],
			twoOptions: [],
			threeOptions: [],
			majorList: [],
			collegeList: [],
			majorDetail: [],
			scrollTop1: 0,
			scrollTop2: 0,
			timer: null,
			loading1: false,
			loading2: false,
			// 冲稳保
			cwb1: {
				sco1: 0,
				sco2: 0,
				sco3: 0
			},
			cwb2: {
				sco1: 0,
				sco2: 0,
				sco3: 0
			},
			// 专业信息是否加载
			majorLoaded: false,
			// 院校信息是否加载
			collegeLoaded: false,
			// 22-2-15
			BatchList: [],
			pcvalue: '',
			xkoptions: [],
			xkvalue: '',
			zyoptions: [],
			zyvalue: '',
			zyaoptions: [],
			zyavalue: '',
			zyName: '',
			// 22-2-14
			isYuanShua: 0,
			yuanShuList: [
				{
					id: 0,
					isSelect: true,
					name: '不限'
				},
				{
					id: 1,
					isSelect: false,
					name: '北京市'
				},
				{
					id: 2,
					isSelect: false,
					name: '河北省'
				},
				{
					id: 3,
					isSelect: false,
					name: '山西省'
				},
				{
					id: 4,
					isSelect: false,
					name: '辽宁省'
				},
				{
					id: 5,
					isSelect: false,
					name: '吉林省'
				},
				{
					id: 6,
					isSelect: false,
					name: '黑龙江省'
				},
				{
					id: 7,
					isSelect: false,
					name: '江苏省'
				},
				{
					id: 8,
					isSelect: false,
					name: '浙江省'
				},
				{
					id: 9,
					isSelect: false,
					name: '安徽省'
				},
				{
					id: 10,
					isSelect: false,
					name: '福建省'
				},
				{
					id: 11,
					isSelect: false,
					name: '江西省'
				},
				{
					id: 12,
					isSelect: false,
					name: '山东省'
				},
				{
					id: 13,
					isSelect: false,
					name: '河南省'
				},
				{
					id: 14,
					isSelect: false,
					name: '湖北省'
				},
				{
					id: 15,
					isSelect: false,
					name: '湖南省'
				},
				{
					id: 16,
					isSelect: false,
					name: '广东省'
				},
				{
					id: 17,
					isSelect: false,
					name: '海南省'
				},
				{
					id: 18,
					isSelect: false,
					name: '四川省'
				},
				{
					id: 19,
					name: '贵州省',
					isSelect: false
				},
				{
					id: 0,
					name: '云南省',
					isSelect: false
				},
				{
					id: 21,
					name: '陕西省',
					isSelect: false
				},
				{
					id: 22,
					name: '甘肃省',
					isSelect: false
				},
				{
					id: 23,
					name: '青海省',
					isSelect: false
				},
				{
					id: 24,
					isSelect: false,
					name: '台湾省'
				},
				{
					id: 25,
					isSelect: false,
					name: '内蒙古'
				},
				{
					id: 26,
					isSelect: false,
					name: '广西壮族'
				},
				{
					id: 27,
					isSelect: false,
					name: '西藏'
				},
				{
					id: 28,
					isSelect: false,
					name: '宁夏回族'
				},
				{
					id: 29,
					isSelect: false,
					name: '新疆维吾尔'
				},
				{
					id: 30,
					isSelect: false,
					name: '天津市'
				},
				{
					id: 31,
					isSelect: false,
					name: '上海市'
				},
				{
					id: 32,
					isSelect: false,
					name: '重庆市'
				},
				{
					id: 33,
					isSelect: false,
					name: '香港'
				},
				{
					id: 34,
					isSelect: false,
					name: '澳门'
				}
			],
			isYuanShub: 0,
			yuanShubList: [
				{
					id: 0,
					isSelect: true,
					name: '不限'
				}
			],
			isYuanShuc: 0,
			yuanShucList: [
				{
					id: 0,
					isSelect: true,
					name: '不限'
				},
				{
					id: 1,
					isSelect: false,
					name: '985'
				},
				{
					id: 2,
					isSelect: false,
					name: '211'
				},
				{
					id: 3,
					name: '双一流',
					isSelect: false
				},
				{
					id: 4,
					isSelect: false,
					name: '国家重点'
				},
				{
					id: 5,
					isSelect: false,
					name: '省重点'
				}
			],
			isYuanShud: 0,
			yuanShudList: [
				{
					id: 0,
					isSelect: true,
					name: '不限'
				},
				{
					id: 1,
					isSelect: false,
					name: '公办'
				},
				{
					id: 2,
					isSelect: false,
					name: '民办'
				},
				{
					id: 3,
					isSelect: false,
					name: '中外/港澳'
				}
			],
			hotList: [{}, {}, {}, {}, {}],
			isHot: 0,
			isAllBox: true,
			// 专业
			isZhuan: false,
			// 学院
			isXueYuan: false,
			zhuanList: [],
			XiaoList: [], // 获取模糊查询院校list
			ZiTotal: 0,
			chongTotal: 0,
			BaoTotal: 0,
			WenTotal: 0,
			item: {},
			loadMoreing: false,
			// 刻度
			keduList: [],
			screeHeight: document.body.clientHeight,
			isPage: false,
			BBBatchList: [],
			ppcvalue: '',
			yxloading: null,
			collegeListNum: 0,
			selectNum: 0,
			firstCollege: 1
		};
	},
	components: {
		CollegeMajor
	},
	// activated() {
	//     if (this.$parent.oldSelectId > 0 && this.$parent.oldSelectId !== this.$parent.selectId) {
	//         this.resetCondition(false);
	//         this.getConditions();
	//         this.getColumnName();
	//         this.getUserAccurateScore();
	//     }
	// },
	created() {
		this.getCollegesMold();
		console.log('that.$parent.selectType', this.$parent.selectType);
		// this.selectedCollegeMajor = this.$util.clone(this.$parent.selectedCollegeMajor);
		// this.$nextTick(() => {
		console.log('that.$route.query.keythat.$route.query.key', this.$route.query.key);
		this.getConditions();
		this.getColumnName();
		this.getUserAccurateScore();
		this.getIntendedProfessionalByType();
		this.getAdmissionBatch();
		this.getAdmissionAdmissionBatch();
		// this.getIntendedProfessionalName();
		// this.GetCollegeYX();
		// })
	},
	mounted() {
		// this.tableScrollListener();
		this.reset();
		this.getVolunteer();
	},
	computed: {
		cwb() {
			return this.isTab === 0 ? this.cwb1 : this.cwb2;
		}
	},
	watch: {
		// isTab(newVal) {
		// 	const dom = document.querySelector('.el-table__body-wrapper');
		// 	if (newVal === 0) {
		// 		this.scrollTop2 = dom.scrollTop;
		// 		this.$nextTick(() => {
		// 			dom.scrollTo(0, this.scrollTop1);
		// 		});
		// 	} else {
		// 		this.scrollTop1 = dom.scrollTop;
		// 		this.$nextTick(() => {
		// 			dom.scrollTo(0, this.scrollTop2);
		// 		});
		// 	}
		// }
		pouplist(val) {
			this.ZiTotal = val.length;
		}
	},
	beforeDestroy() {
		if (this.timer) {
			clearTimeout(this.timer);
			this.timer = null;
		}
	},
	methods: {
		
		getCollegesMold() {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/CollegesMold',
				'GET',
				{},
				function(res) {
					console.log('院校类型', res);
					if (res.code==0) {
						var newList = res.data;
						that.yuanShubList= [
							{
								id: 0,
								isSelect: true,
								name: '不限'
							}
						]
						var ixd = 0;
						if(newList.length>0){
							newList.map(a=>{
								ixd++;
								that.yuanShubList.push({
									name: a,
									id: ixd,
									isSelect: false,
								})
							});
						}
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		getVolunteer() {
			var that = this;
			that.$api.HtppRequest(
				'Accurate/Volunteer?selectId=' + that.$parent.selectId,
				'GET',
				{},
				function(res) {
					console.log('获取志愿', res);
					if (res.code === 0) {
						var list = res.data;
						if (list && list.length > 0) {
							list.map(a => {
								var item = {
									id: a.Id,
									major: a.Profession,
									collegeList: a.VolunteerProfessionList ? a.VolunteerProfessionList : [],
									Type: a.Type
								};
								that.pouplist.push(item);
								var majorIdobj = {
									id: item.major.Id,
									Type: a.Type,
									majorList: [],
									majorIdList: []
								};
								if (a.Type === 2) {
									that.selectedMajorId.push(a.ContentId);
								}
								majorIdobj.majorIdList = item.collegeList.map(t => {
									return t.Id;
								});
								that.selectedCollegeMajor.push(majorIdobj);
							});
						}
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		// vueshowloading() {
		// 	this.yxloading = this.$loading({
		// 		lock: true,
		// 		text: 'Loading',
		// 		spinner: 'el-icon-loading',
		// 		background: 'rgba(0, 0, 0, 0.7)'
		// 	});
		// },
		// vuedelloading() {
		// 	console.log('1111111111111', this.yxloading);
		// 	if (this.yxloading) {
		// 		console.log('关闭');
		// 		this.yxloading.close();
		// 		this.yxloading = null;
		// 	}
		// },
		loadData(e) {
			// console.log('滚动', Math.ceil(e.srcElement.scrollTop) + e.srcElement.clientHeight, e.srcElement.scrollHeight);
			if (Math.ceil(e.srcElement.scrollTop) + e.srcElement.clientHeight >= e.srcElement.scrollHeight) {
				if (this.isTab === 0) {
					if (!this.isPage && this.majorList.length > 0) {
						this.AisLoading = true;
						this.ALoading = true;
						// 加载中
						this.isPage = true;
						this.AFrist++;
						this.loadMore();
					} else {
						if (this.AFrist === 1) {
							this.ALoading = true;
						} else {
							this.ALoading = false;
						}
					}
				} else {
					console.log('跟多',this.isPage,this.collegeList.length);
					if (!this.isPage && this.collegeList.length > 0) {
						console.log('加载中loadMore');
						this.BisLoading = true;
						this.BLoading = true;
						// 加载中
						this.isPage = true;
						this.BFrist++;
						this.loadMore();
					} else {
						if (this.BFrist === 1) {
							this.BLoading = true;
						} else {
							this.BLoading = false;
						}
					}
				}
			}
		},
		GetCollege(item) {
			// var that = this;
			// const dto = {
			// 	...that.collegeModel,
			// 	pageSize: 999999999,
			// 	CWBType: 0,
			// 	searchCollegesName: item.CollegesName
			// };
			// this.$api.getAccurateGetProfession(dto).then(res => {
			// 	const majorList = item.majorList || [];
			// 	const list = res.data.map(a => {
			// 		a.selected = selectedCollegeMajorItem ? selectedCollegeMajorItem.majorIdList.includes(a.Id) : false;
			// 		return a;
			// 	});
			// 	majorList.push({
			// 		dtoStr,
			// 		list
			// 	});
			// 	item.majorList = majorList;
			// 	this.currentCollegeMajor.list = this.$util.clone(list);
			// 	this.collogeMajorVisible = true;
			// });
		},
		valueChage(e, type) {
			// console.log('111111111111111', e, type);
			if (type === 1) {
				if (e > 50) {
					this.atiValue = 50;
				}
			} else if (type === 2) {
				if (parseInt(e) >= parseInt(this.atiValue)) {
					this.dtiValue = this.atiValue - 1;
				}
			} else if (type === 3) {
				if (parseInt(e) >= parseInt(this.dtiValue)) {
					this.gtiValue = this.dtiValue - 1;
				}
			} else if (type === 4) {
				if (parseInt(e) < parseInt(-50)) {
					this.htiValue = -50;
				}
				if (parseInt(e) >= parseInt(this.gtiValue)) {
					this.htiValue = this.gtiValue - 1;
				}
			}
			if (type === 1 || type === 2) {
				var ctiValue = this.ctiValue || 0;
				this.NumChage(ctiValue, 1);
			} else if (type === 3) {
				var ftiValue = this.ftiValue || 0;
				this.NumChage(ftiValue, 2);
			} else if (type === 4) {
				var jtiValue = this.jtiValue || 0;
				this.NumChage(jtiValue, 3);
			}
		},
		setErrorMsg(type) {
			if (!this.atiValue) {
				this.$util.showError('请先填写冲分数区间1');
				return true;
			}
			if (this.dtiValue === null || this.dtiValue.length === 0) {
				this.$util.showError('请先填写冲分数区间2');
				return true;
			}
			if (type === 2 || type === 3) {
				if (!this.gtiValue) {
					this.$util.showError('请先填写稳分数');
					return true;
				}
			}
			if (type === 3) {
				if (!this.htiValue) {
					this.$util.showError('请先填写保分数');
					return true;
				}
			}
		},
		NumChage(e, type) {
			var value = 0;
			if (type === 1) {
				if (e <= 0) {
					this.ctiValue = 1;
				}
				if (this.setErrorMsg(1)) {
					return;
				}
				value = parseFloat((this.atiValue - this.dtiValue) / this.ctiValue);
			} else if (type === 2) {
				if (e <= 0) {
					this.ftiValue = 1;
				}
				if (this.setErrorMsg(2)) {
					return;
				}
				value = parseFloat((this.dtiValue - this.gtiValue) / this.ftiValue);
			} else if (type === 3) {
				if (e <= 0) {
					this.jtiValue = 1;
				}
				if (this.setErrorMsg(3)) {
					return;
				}
				value = parseFloat((this.gtiValue - this.htiValue) / this.jtiValue);
			}
			if (value > parseInt(value) && parseInt(value) !== 0) {
				value = parseInt(value) + '.5';
				value = parseFloat(value);
			} else {
				value = Math.round(value);
			}
			this.SetValue(value, type);
		},
		SetValue(value, type) {
			var item = {
				type: '',
				value: value,
				list: []
			};
			if (type === 1) {
				item.type = 1;
				for (var i = 0; i < this.ctiValue; i++) {
					var anum = this.atiValue - value * i;
					var it = {
						value: anum
					};
					if (anum >= this.dtiValue) {
						item.list.push(it);
					}
				}
			} else if (type === 2) {
				item.type = 2;
				for (var j = 0; j < this.ftiValue; j++) {
					var num = this.dtiValue - value * (j + 1);
					var itj = {
						value: num
					};
					if (num >= this.gtiValue) {
						item.list.push(itj);
					}
				}
			} else if (type === 3) {
				item.type = 3;
				for (var k = 0; k < this.jtiValue; k++) {
					var cnum = this.gtiValue - value * (k + 1);
					var itk = {
						value: cnum
					};
					if (cnum >= this.htiValue) {
						item.list.push(itk);
					}
				}
			}
			if (this.keduList && this.keduList.length > 0) {
				if (this.keduList.length >= type) {
					this.keduList[type - 1] = item;
				} else {
					this.keduList.push(item);
				}
			} else {
				this.keduList.push(item);
			}
			this.$forceUpdate();
			console.log('this.keduList', this.keduList);
		},
		isSetChiClick() {
			this.isSetChi = !this.isSetChi;
			if (this.isSetChi) {
				this.isSetChiDiv = true;
			} else {
				this.isSetChiDiv = false;
			}
		},
		topD() {
			console.log('点击回到顶部');
			// let top = document.documentElement.scrollTop || document.body.scrollTop;
			// // 实现滚动效果
			// const timeTop = setInterval(() => {
			// 	document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
			// 	if (top <= 0) {
			// 		clearInterval(timeTop);
			// 	}
			// }, 10);
			// const dom = document.querySelector('.gaokao-content');
			// dom.scrollTop = 0;
			this.$refs.gaokaolist.scrollTop = 0;
			console.log('顶部', this.$refs.gaokaolist);
		},

		onYuanShua(item) {
			// this.isYuanShua = index;s
			if (item.id === 0) {
				this.yuanShuList.forEach(a => {
					a.isSelect = false;
				});
				item.isSelect = true;
			} else {
				this.yuanShuList[0].isSelect = false;
				item.isSelect = !item.isSelect;
			}
		},
		onYuanShub(item) {
			// this.isYuanShub = index;
			if (item.id === 0) {
				this.yuanShubList.forEach(a => {
					a.isSelect = false;
				});
				item.isSelect = true;
			} else {
				this.yuanShubList[0].isSelect = false;
				item.isSelect = !item.isSelect;
			}
		},
		onYuanShuc(item) {
			// this.isYuanShuc = index;
			if (item.id === 0) {
				this.yuanShucList.forEach(a => {
					a.isSelect = false;
				});
				item.isSelect = true;
			} else {
				this.yuanShucList[0].isSelect = false;
				item.isSelect = !item.isSelect;
			}
		},
		onYuanShud(item) {
			// yuanShudList
			// this.isYuanShud = index;
			if (item.id === 0) {
				this.yuanShudList.forEach(a => {
					a.isSelect = false;
				});
				item.isSelect = true;
			} else {
				this.yuanShudList[0].isSelect = false;
				item.isSelect = !item.isSelect;
			}
		},
		// 重置搜索条件
		reset(type) {
			this.restPop();
			this.Chongzhi();
			if (type) {
				this.collegeModel.page = 1;
				this.collegePreferredSubject = '';
				this.collegeRequirementsSubjects = '';
				this.collegeModel.preferredSubject = '';
				this.collegeModel.requirementsSubjects = '';
				this.collegeModel.searchCollegesName = '';
				this.YXName = '';
				this.ppcvalue = undefined;
				this.$forceUpdate();
			} else {
				this.majorModel.page = 1;
				this.majorModel.searchCollegesName = '';
				this.majorModel.searchMajorName = '';
				this.majorModel.preferredSubject = '';
				this.majorModel.requirementsSubjects = '';
				this.preferredSubject = undefined;
				this.requirementsSubjects = undefined;
				this.pcvalue = undefined;
				this.xkvalue = undefined;
				this.zyvalue = undefined;
				this.zyavalue = undefined;
				this.pcvalue = undefined;
				this.zyoptions = [];
				this.zyaoptions = [];
				this.YXName = '';
				this.zyName = '';
				this.$forceUpdate();
			}
		},
		Chongzhi() {
			if (this.isTab === 1) {
				this.majorModel.searchCitysCode = '';
				this.majorModel.CollegesType = '';
				this.majorModel.CollegesMold = '';
				this.majorModel.Characte = '';
			} else {
				this.collegeModel.searchCitysCode = '';
				this.collegeModel.CollegesType = '';
				this.collegeModel.CollegesMold = '';
				this.collegeModel.Characte = '';
			}
		},
		getAdmissionBatch() {
			var that = this;
			that.$api.HtppRequest(
				'Accurate/Profession/Batch?type=1&vId=' + that.$parent.firstId,
				'GET',
				{},
				function(res) {
					if (res.code === 0) {
						that.BatchList = res.data;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		getAdmissionAdmissionBatch() {
			var that = this;
			that.$api.HtppRequest(
				'Accurate/Profession/Batch?type=2&vId=' + that.$parent.firstId,
				'GET',
				{},
				function(res) {
					if (res.code === 0) {
						that.BBBatchList = res.data;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		getProfessional() {
			var that = this;
			that.$api.HtppRequest(
				'Accurate/Profession/GetIntendedProfessional?Type=2&SubjectCategories=' + that.xkvalue + '&Primarily=' + that.$parent.selectType,
				'GET',
				{},
				function(res) {
					if (res.code === 0) {
						that.zyoptions = res.data;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		setProfessional(e) {
			// 获取专业
			this.getIntendedProfessionalPage();
		},
		getIntendedProfessionalPage() {
			var that = this;
			that.$api.HtppRequest(
				'Accurate/Profession/GetIntendedProfessional?Type=3&SubjectCategories=' + this.xkvalue + '&Professional=' + this.zyvalue + '&Primarily=' + that.$parent.selectType,
				'GET',
				{},
				function(res) {
					console.log('获取列表', res);
					if (res.code === 0) {
						that.zyaoptions = res.data;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		querySearchYx() {
			if (this.YXName) {
				var NameList = this.YXName.split(' ');
				var nameStr = NameList.map(a => {
					return a;
				}).join(',');
				this.GetCollegeYx(nameStr);
			} else {
				this.serchYXList = [];
				this.YXNameListPop = true;
			}
		},
		queryYx() {
			if (!this.YXName) {
				this.serchYXList = [];
				this.YXNameListPop = false;
			}
		},
		handleSelectYX(item) {
			this.YXName = this.YXNameList.find(a => a.Id === item.Id).CollegesName;
			this.YXNameListPop = false;
		},
		GetCollegeYx(keyword) {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/GetCollege?keyword=' + keyword,
				'GET',
				{},
				function(res) {
					console.log('获取列表', res);
					if (res.flag) {
						if (res.data.length > 0) {
							that.YXNameList = JSON.parse(JSON.stringify(res.data));
							var Info = res.data;
							var keyList = keyword.split(',');
							Info.map(a => {
								a.isSelect = false;
								keyList.map(b => {
									a.CollegesName = a.CollegesName.replace(b, '<span style="color: red">' + b + '</span>');
								});
							});
							that.serchYXList = Info;
							console.log('this.YXNameList', that.YXNameList);
							that.YXNameListPop = true;
							that.$forceUpdate();
						}
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		querySearch() {
			console.log('11111111111111', this.zyName);
			if (!this.zyName) {
				this.serchZyList = [];
				this.zyNameListPop = false;
			}
		},
		querySearchAsync() {
			// this.getIntendedProfessionalName();
			if (this.zyName) {
				var List = JSON.parse(JSON.stringify(this.zyNameList));
				var tmp = List.filter(a => a.ProfessionalName.includes(this.zyName));
				tmp.map(a => {
					a.ProfessionalName = a.ProfessionalName.replace(this.zyName, '<span style="color: red">' + this.zyName + '</span>');
				});
				this.serchZyList = tmp;
				this.zyNameListPop = true;
			} else {
				this.serchZyList = [];
				this.zyNameListPop = false;
				console.log('1111111111', this.serchZyList);
			}
		},
		handleSelect(item) {
			var tmp = this.zyNameList.filter(a => a.Id === item.Id);
			this.zyName = tmp[0].ProfessionalName;
			this.zyNameListPop = false;
		},
		// 搜索专业名称列表
		getIntendedProfessionalName() {
			var that = this;
			var dataOjb = {
				page: 1,
				size: 999,
				subjectCategories: '',
				professional: '',
				keyName: that.zyName,
				Primarily: 0, // 1.本科 2.专科
				RecommendType: '' // 推荐类型/推荐专业
			};
			console.log(dataOjb);
			that.$api.HtppRequest(
				'SystemData/GetIntendedProfessionalPage',
				'POST',
				dataOjb,
				function(res) {
					console.log('获取列表', res);
					if (res.flag) {
						if (res.list.length > 0) {
							var Info = res.list;
							Info.map(a => {
								a.isSelect = false;
								// a.ProfessionalName = a.ProfessionalName.replace(that.zyName,
								// 	'<span style="color: red">' + that.zyName + '</span>');
							});
							that.zyNameList = Info;
							console.log('this.zyNameList', that.zyNameList);
							that.$forceUpdate();
						}
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		setSubjectCategories(e) {
			this.getProfessional();
		},
		// 学科门类
		getIntendedProfessionalByType() {
			var that = this;
			that.$api.HtppRequest(
				'Accurate/Profession/GetIntendedProfessional?Type=1&Primarily=' + that.$parent.selectType,
				'GET',
				{},
				function(res) {
					if (res.code === 0) {
						console.log('学科门类', res);
						that.xkoptions = res.data;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		allView(item) {
			item.isAllBox = !item.isAllBox;
		},
		// onYuanShua(index) {
		// 	if (index === 0) {
		// 		// 如果点击的是不限
		// 		this.yuanShuList.map(el => {
		// 			el.choose = el.name === '不限';
		// 		});
		// 	} else {
		// 		this.yuanShuList[0].choose = false;
		// 		this.yuanShuList[index].choose = !this.yuanShuList[index].choose;
		// 	}
		// 	this.$forceUpdate();
		// 	this.isYuanShua = index;
		// },
		// onYuanShub(index) {
		// 	if (index === 0) {
		// 		this.yuanShubList.map(el => {
		// 			el.choose = el.name === '不限';
		// 		});
		// 	} else {
		// 		this.yuanShubList[0].choose = false;
		// 		this.yuanShubList[index].choose = !this.yuanShubList[index].choose;
		// 	}
		// 	this.$forceUpdate();
		// 	this.isYuanShub = index;
		// },'
		// onYuanShuc(index) {
		// 	this.isYuanShuc = index;
		// },
		// onYuanShud(index) {
		// 	this.isYuanShud = index;
		// },
		onHotTab(index) {
			this.isHot = index;
		},
		yuanXiaoTo(item) {
			// 院校名称
			window.open(`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${item.Name}`);
			// 专业  majorinfo
			// this.$router.push('/majorinfo')
			// this.$router.push({
			// 	path: './schoolinfo',
			// 	query: {
			// 		schoolname: item.schoolname
			// 	}
			// });
		},
		zhuanYeTo(item) {
			// 院校名称
			// window.open(
			// 	`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${item.SchoolName}`);
			// 专业  majorinfo
			// this.$router.push('/majorinfo')
			var routeUrl = this.$router.resolve({
				path: '/majorinfo',
				query: {
					Id: item.Id
				}
			});
			window.open(routeUrl.href, '_blank');
		},
		RefullIsPopup() {
			var list = this.pouplist;
			var chongList = list.filter(a => {
				if (a.major.Position === '冲') {
					return a;
				}
			});
			var baoList = list.filter(a => {
				if (a.major.Position === '保') {
					return a;
				}
			});
			var WenList = list.filter(a => {
				if (a.major.Position === '稳') {
					return a;
				}
			});
			this.chongTotal = chongList.length;
			var pouplist = [];
			if (chongList && chongList.length > 0) {
				chongList.forEach(a => {
					pouplist.push(a);
				});
			}
			this.WenTotal = WenList.length;
			if (WenList && WenList.length > 0) {
				WenList.forEach(a => {
					pouplist.push(a);
				});
			}
			this.BaoTotal = baoList.length;
			if (baoList && baoList.length > 0) {
				baoList.forEach(a => {
					pouplist.push(a);
				});
			}
			this.pouplist = pouplist;
			this.isPopup = false;
		},
		QuitIsPopup() {
			this.isPopup = true;
		},
		// 22-2-14              22-4-20 张燕确定 选择后直接添加到志愿表，院校不选择专业。
		// 选择/取消选择院校     选择后就加到志愿表，现在有什么问题？
		handleSelectedChange(it) {
			var id = it.Id;
			it.selected = !it.selected;
			var selected = it.selected;
			console.log('选择/取消选择院校', id, selected);
			if (this.isTab === 1) {
				console.log('this.isTab=1');
				const index = this.selectedCollegeMajor.findIndex(a => a.id === id);
				if (index >= 0 && !selected) {
					this.selectedCollegeMajor.splice(index, 1);
					const college = this.collegeList.find(a => a.Id === id);
					if (college) {
						const selectedCollegeMajorObj = {};
						const dto = {
							...this.collegeModel,
							pageSize: 999999999,
							CWBType: 0,
							searchCollegesName: college.CollegesName
						};
						const dtoStr = JSON.stringify(dto);
						if (college.majorList) {
							const collegeMajorItem = college.majorList.find(a => a.dtoStr === dtoStr);
							if (collegeMajorItem) {
								selectedCollegeMajorObj.majorIdList = collegeMajorItem.list.map(a => a.Id);
								if (selectedCollegeMajorObj.majorIdList.length > 0) {
									this.selectedCollegeMajor.push(selectedCollegeMajorObj);
								} else {
									this.$util.showError('该院校暂无可选择专业');
									this.selectedCollegeMajor.push(selectedCollegeMajorObj);
								}
							}
						}
						if (!selectedCollegeMajorObj.majorIdList) {
							this.$api.getAccurateGetProfession(dto).then(res => {
								const majorList = college.majorList || [];
								const list = res.data.map(a => {
									a.selected = false;
									return a;
								});
								majorList.push({
									dtoStr,
									list
								});
								college.majorList = majorList;
								selectedCollegeMajorObj.majorIdList = list.map(a => a.Id);
								if (selectedCollegeMajorObj.majorIdList.length > 0) {
									this.selectedCollegeMajor.push(selectedCollegeMajorObj);
								} else {
									this.$util.showError('该院校暂无可选择专业');
									this.selectedCollegeMajor.push(selectedCollegeMajorObj);
								}
							});
						}
					}
				}
			} else {
				console.log('this.isTab=2');
				const index = this.selectedMajorId.findIndex(a => a === id);
				var majorItem = this.majorList.find(a => a.Id === id);
				console.log('majorItem',majorItem);
					console.log('this.majorList',this.majorList);
				if (selected && index < 0) {
					majorItem.Year1 = majorItem.YearsDate1;
					var item = {
						major: majorItem,
						collegeList: [],
						Type: 2
					};
					this.pouplist.push(item);
					this.selectedMajorId.push(id);
				} else if (!selected && index >= 0) {
					this.selectedMajorId.splice(index, 1);
					const ind = this.pouplist.findIndex(a => a.major.Id === id && a.Type === 2);
					this.pouplist.splice(ind, 1);
				}
			}
			this.ZiTotal = this.pouplist.length || 0;
			console.log(this.pouplist);
		},
		goUpupup(item, index) {
			if (index < 1) return;
			this.pouplist[index] = this.pouplist.splice(index - 1, 1, this.pouplist[index])[0];
		},
		goDown(item, index) {
			if (index >= this.pouplist.length - 1) return;
			this.pouplist[index] = this.pouplist.splice(index + 1, 1, this.pouplist[index])[0];
		},
		// 删除志愿
		handleDelete(id) {
			console.log('删除', id);
			this.$api
				.accurateDeleteVolunteer({
					Id: id
				})
				.then(res => {
					this.$util.showOk('删除成功');
				});
		},
		deletePoup(item, index, Type) {
			if (Type === 1) {
				const ind = this.selectedCollegeMajor.findIndex(a => a.id === item.major.Id);
				this.selectedCollegeMajor.splice(ind, 1);
				console.log('this.selectedCollegeMajor', this.selectedCollegeMajor);
				console.log('this.pouplist', this.pouplist);
				const collegeindex = this.collegeList.findIndex(a => a.Id === item.major.Id);
				if (collegeindex >= 0) {
					this.collegeList[collegeindex].selected = false;
				}
			} else {
				console.log(item.major.Id);
				console.log('majorListd',this.majorList);
				const majorIndex = this.majorList.findIndex(a => a.Id === item.major.Id);
				console.log('majorIndex',majorIndex);
				if(majorIndex>=0){
					this.majorList[majorIndex].selected = false;
				}
				const selectedindex = this.selectedMajorId.findIndex(a => a === item.major.Id);
				if (selectedindex >= 0) {
					this.selectedMajorId.splice(selectedindex, 1);
				}
			}
			this.pouplist.splice(index, 1);
			this.ZiTotal = this.pouplist.length || 0;
			this.RefullIsPopup();
			if (item.id) {
				this.handleDelete(item.id);
			}
		},
		deleteCollege(item, index, ind) {
			console.log('111111111111', index, ind);
			const selectedInd = this.selectedCollegeMajor.findIndex(a => a.id === this.pouplist[index].major.Id);
			console.log('222222222222222', selectedInd);
			const majorId = this.selectedCollegeMajor[selectedInd].majorIdList.findIndex(a => a === item.Id);
			this.selectedCollegeMajor[selectedInd].majorIdList.splice(majorId, 1);
			this.pouplist[index].collegeList.splice(ind, 1);
			if (this.selectedCollegeMajor[selectedInd].majorIdList.length === 0) {
				console.log('1111111111111111111111111111');
				this.selectedCollegeMajor.splice(selectedInd, 1);
				const collegeindex = this.collegeList.findIndex(a => a.Id === this.pouplist[selectedInd].major.Id);
				this.collegeList[collegeindex].selected = false;
			}
			if (this.pouplist[index].collegeList.length === 0) {
				this.pouplist.splice(index, 1);
			}
			this.ZiTotal = this.pouplist.length || 0;
			this.RefullIsPopup();
			if (item.ParentId) {
				this.handleDelete(item.ParentId);
			}
		},
		beforecCloseCollegeMajor(done){
			this.closeCollegeMajor(false);
			done();
		},
		// 关闭院校专业弹窗
		closeCollegeMajor(needSave) {
			// console.log('needSave', needSave);
			const college = this.collegeList.find(a => a.Id === this.currentCollegeMajor.id);
			if (college && college.majorList) {
				const collegeMajorItem = college.majorList.find(a => a.dtoStr === this.currentCollegeMajor.dtoStr);
				if (collegeMajorItem && needSave) {
					collegeMajorItem.list = this.$util.clone(this.currentCollegeMajor.list);
					const selectedIdArr = collegeMajorItem.list.filter(a => a.selected).map(a => a.Id);
					const selectedCollegeMajorItem = {
						id: college.Id,
						majorIdList: selectedIdArr
					};
					const selectedCollegeMajorIndex = this.selectedCollegeMajor.findIndex(a => a.id === college.Id);
					if (selectedCollegeMajorIndex >= 0) {
						this.selectedCollegeMajor[selectedCollegeMajorIndex] = selectedCollegeMajorItem;
					} else {
						this.selectedCollegeMajor.push(selectedCollegeMajorItem);
					}
					college.selected = selectedIdArr.length > 0;
				}
				var tmp = collegeMajorItem.list.filter(a => a.selected);
				if (tmp && tmp.length > 0) {
					const ind = this.pouplist.findIndex(a => a.major.Id === this.currentCollegeMajor.id);
					var selectCollege = [];
					tmp.map(a => {
						var itt = {
							Id: a.Id,
							Name: a.MajorName,
							LowestOrder: a.LowestOrder,
							LowestScore: a.LowestScore,
							Position: a.Position,
							Year1:a.YearsDate1,
							Remarks:a.Remarks
						};
						// console.log('a==',a);
						// console.log('itt==',itt);
						selectCollege.push(itt);
					});
					this.pouplist[ind].collegeList = selectCollege;
					const index = this.collegeList.findIndex(a => a.Id === this.currentCollegeMajor.id);
					this.collegeList[index].selected = true;
					var selectIndex = this.selectedCollegeMajor.findIndex(a => a.id === this.collegeList[index].Id);
					this.selectedCollegeMajor[selectIndex].majorIdList = tmp.map(a => a.Id);
				} else {
					const index = this.collegeList.findIndex(a => a.Id === this.currentCollegeMajor.id);
					const ind = this.selectedCollegeMajor.findIndex(a => a.Id === this.currentCollegeMajor.id);
					const poupIndex = this.pouplist.findIndex(a => a.major.Id === this.currentCollegeMajor.id);
					this.selectedCollegeMajor.splice(ind, 1);
					this.pouplist.splice(poupIndex, 1);
					this.collegeList[index].selected = false;
				}
				this.ZiTotal = this.pouplist.length || 0;
			}
			// console.log('this.selectedCollegeMajor', this.selectedCollegeMajor);
			// console.log('this.pouplist', this.pouplist);
			this.collogeMajorVisible = false;
		},
		// 显示院校中的专业
		showCollegeMajor(id,ism = null) {
			const college = this.collegeList.find(a => a.Id === id);
			console.log('111111111111', college);
			if (!college) {
				this.$util.showError('数据错误');
				return;
			}
			this.currentCollegeMajor.id = id;
			this.currentCollegeMajor.name = college.CollegesName;
			const dto = {
				...this.collegeModel,
				page: 1,
				pageSize: 999999999,
				CWBType: 0,
				CollegesName: college.CollegesName,
				isAll: true
			};
			if(ism){
				dto.isMajorNames = false;
			}
			const dtoStr = JSON.stringify(dto);
			this.currentCollegeMajor.dtoStr = dtoStr;
			const selectedCollegeMajorItem = this.selectedCollegeMajor.find(a => a.id === college.Id);
			if (college.majorList && college.majorList.some(a => a.dtoStr === dtoStr)) {
				const collegeMajorItem = college.majorList.find(a => a.dtoStr === dtoStr);
				this.currentCollegeMajor.list = this.$util.clone(
					collegeMajorItem.list.map(a => {
						a.selected = selectedCollegeMajorItem ? selectedCollegeMajorItem.majorIdList.includes(a.Id) : false;
						return a;
					})
				);
				this.collogeMajorVisible = true;
				console.log('this.currentCollegeMajor.list', this.currentCollegeMajor.list);
			} else {
				this.$api.getAccurateGetProfession(dto).then(res => {
					console.log('dto', dto);
					console.log('res', res);
					const majorList = college.majorList || [];
					const list = res.data.filter(a => {
						a.selected = selectedCollegeMajorItem ? selectedCollegeMajorItem.majorIdList.includes(a.Id) : false;
						return a.Average==college.Average;
					});
					majorList.push({
						dtoStr,
						list
					});
					college.majorList = majorList;
					this.currentCollegeMajor.list = this.$util.clone(list);
					this.collogeMajorVisible = true;
					console.log('this.currentCollegeMajor.list', this.currentCollegeMajor.list);
				});
			}
			var ispoup = this.pouplist.find(a => a.major.Id === id);
			if (!ispoup) {
				var item = {
					major: college,
					collegeList: [],
					Type: 1,
				};
				this.pouplist.push(item);
			}
			var isSelect = this.selectedCollegeMajor.find(a => a.id === id);
			if (!isSelect) {
				var selectedCollegeMajorObj = {
					id: id,
					majorIdList: [],
					Type: 1
				};
				this.selectedCollegeMajor.push(selectedCollegeMajorObj);
			}
			console.log('this.selectedCollegeMajor', this.selectedCollegeMajor);
			console.log('this.pouplist', this.pouplist);
		},
		// 选择冲稳保
		selectCwb(type) {
			if (this.isTab === 0) {
				this.majorModel.CWBType = this.majorModel.CWBType === type ? 0 : type;
				this.majorModel.page = 1;
				this.majorList = [];
				this.getList(0, true);
			} else {
				this.collegeModel.CWBType = this.collegeModel.CWBType === type ? 0 : type;
				this.collegeModel.page = 1;
				this.collegeList = [];
				this.getList(1, true);
			}
		},
		// 跳转招生章程
		goSolution(url) {
			window.open(url);
		},
		// table触底加载更多
		tableScrollListener() {
			const dom = document.querySelector('.el-table__body-wrapper');
			dom.addEventListener('scroll', () => {
				const scrollDistance = dom.scrollHeight - dom.scrollTop - dom.clientHeight;
				if (scrollDistance <= 5) {
					if (this.timer) {
						clearTimeout(this.timer);
						this.timer = null;
					}
					this.timer = setTimeout(() => {
						this.timer = null;
						this.loadMore();
					}, 200);
				}
			});
		},
		// 加载更多
		loadMore() {
			this.$nextTick(() => {
				if (this.isTab === 0) {
					// this.majorTotalPage > this.majorModel.page && !this.loading1
					if (this.ALoading) {
						this.majorModel.page += 1;
						this.getList(0);
					}
				} else {
					// this.collegeTotalPage > this.collegeModel.page && !this.loading2
					if (this.BLoading) {
						this.collegeModel.page += 1;
						this.getList(1);
					}
				}
			});
		},
		// 获取筛选条件的数据
		async getConditions() {
			const resArr = await Promise.all([this.$api.getPreferredSubject(), this.$api.getRequirementsSubjects(), this.$api.getAccurateCity()]);
			resArr.forEach((res, index) => {
				switch (index) {
					case 0:
						this.oneOptions = res.data;
						break;
					case 1:
						this.twoOptions = res.data;
						break;
					case 2:
						this.threeOptions = res.data;
						break;
				}
			});
		},
		// 获取专业/院校列表
		async getList(tab = -1, firstLoad = false) {
			if (tab < 0) {
				tab = this.isTab;
			}
			console.log('开始查询数据tab', tab);
			if (tab === 0) {
				if (firstLoad) {
					// this.vueshowloading();
					this.AisLoading = true;
				}
				// this.ALoading = true;
				this.loading1 = true;
				this.isPage = true;
				const dto = this.$util.clone(this.majorModel);
				console.log('22222', dto);
				const res = await this.$api.getProfession2022(dto, false);
				this.majorLoaded = true;
				this.loading1 = false;
				// this.majorList.push(...res.data.map(a => ({ ...a, selected: false })));
				console.log('检查数据', this.selectedMajorId);
				if(res.data.length>0){
					this.majorList.push(
						...res.data.map(a => {
							if (a.Remarks && a.Remarks.includes('新增')) {
								a.YearsDate1 = null;
							}
							return {
								...a,
								isPop: a.Remarks ? a.Remarks.includes('新增') : false,
								isYears1: a.YearsDate1 !== null,
								isYears2: a.YearsDate2 !== null,
								isYears3: a.YearsDate3 !== null,
								selected: firstLoad && this.selectedMajorId.includes(a.Id)
							};
						})
					);
				}
				this.loadMoreing = res.data.length < 20;
				this.majorTotalPage = res.totalPage;
				if (dto.page === 1) {
					this.cwb1 = res.cwb;
					console.log('设置冲稳保', this.cwb1);
				}
				this.ANoData = this.majorList.length === 0;
				this.isPage = false;
				this.ALoading = res.data.length === 20;
			} else {
				if (firstLoad) {
					// this.vueshowloading();
					this.BisLoading = true;
				}
				this.loading2 = true;
				this.isPage = true;
				const dto = this.$util.clone(this.collegeModel);
				console.log('22222', dto);
				const res = await this.$api.getAccurateGetAdmission(dto, false);
				this.collegeLoaded = true;
				this.loading2 = false;
				// this.collegeList.push(...res.data.map(a => ({ ...a, selected: false })));
				if(res.data.length>0){
					this.collegeList.push(
						...res.data.map(a => {
							if (a.Remarks && a.Remarks.includes('新增')) {
								a.YearsDate1 = null;
							}
							return {
								...a,
								isPop: a.Remarks ? a.Remarks.includes('新增') : false,
								isYears1: a.YearsDate1 !== null,
								isYears2: a.YearsDate2 !== null,
								isYears3: a.YearsDate3 !== null,
								selected: firstLoad && this.selectedCollegeMajor.some(b => b.id === a.Id)
							}
						})
					);
				}else{
					if (dto.page === 1) {
						this.collegeList = [];
					}
				}
				
				this.loadMoreing = res.data.length < 20;
				this.collegeTotalPage = res.totalPage;
				console.log('院校数据',this.collegeList);
				if (dto.page === 1) {
					this.cwb2 = res.cwb;
					console.log('this.cwb2',this.cwb2);
				}
				this.BNoData = this.collegeList.length === 0;
				this.isPage = false;
				this.BLoading = res.data.length === 20;
				// this.vuedelloading();
			}
		},
		// 获取等效分
		async getUserAccurateScore() {
			const res = await this.$api.getUserAccurateScore({
				selectId: this.$parent.firstId
			});
			console.log('等效分', this.$parent.firstId);
			const resData = {};
			for (const key in res.data) {
				if (Object.hasOwnProperty.call(res.data, key)) {
					const element = res.data[key];
					resData[key] = typeof element === 'number' ? element : Number(element);
				}
			}
			this.scoreModel = resData;
			this.majorModel.minScore = resData.stMajoScore + resData.score;
			this.majorModel.maxScore = resData.endMajoScore + resData.score;
			this.majorScore[0] = resData.stMajoScore + resData.score;
			this.majorScore[1] = resData.endMajoScore + resData.score;
			this.collegeModel.minScore = resData.stSchoolScore + resData.score;
			this.collegeModel.maxScore = resData.endSchoolScore + resData.score;
			this.collegeScore[0] = resData.stSchoolScore + resData.score;
			this.collegeScore[1] = resData.endSchoolScore + resData.score;
			this.isTab === 0 && this.getList(0, true);
			this.isTab === 1 && this.getList(1, true);
		},
		// 获取表头名
		async getColumnName() {
			const res = await this.$api.getColumnName();
			this.columnName = res.data;
		},
		// 专业选择首选科目
		handlePreferredSubjectChange(e) {
			this.majorModel.preferredSubject = e.join(',');
		},
		// 专业选择选考科目
		handleRequirementsSubjectsChange(e) {
			this.majorModel.requirementsSubjects = e.join(',');
		},
		// 院校选择首选科目
		handleCollegePreferredSubjectChange(e) {
			this.collegeModel.preferredSubject = e.join(',');
		},
		// 院校选择选考科目
		handleCollegeRequirementsSubjectsChange(e) {
			this.collegeModel.requirementsSubjects = e.join(',');
		},
		// 选择院校地区
		handleSearchCitysCodeChange(e) {
			console.log('e', e);
			this.isTab === 0 ? (this.majorModel.searchCitysCode = e.join(',')) : (this.collegeModel.searchCitysCode = e.join(','));
		},
		// 点击我的意向专业
		handleMajorName() {
			if (this.isTab === 0) {
				this.majorModel.isMajorNames = !this.majorModel.isMajorNames;
				this.majorList = [];
				this.majorTotalPage = 0;
				this.majorModel.page = 1;
			} else {
				this.collegeModel.isMajorNames = !this.collegeModel.isMajorNames;
				this.collegeList = [];
				this.collegeTotalPage = 0;
				this.collegeModel.page = 1;
			}
			this.getList(this.isTab, true);
		},
		// 点击我的意向院校
		handleCollegesName() {
			if (this.isTab === 0) {
				this.majorModel.isCollegesNames = !this.majorModel.isCollegesNames;
				this.majorList = [];
				this.majorTotalPage = 0;
				this.majorModel.page = 1;
			} else {
				this.collegeModel.isCollegesNames = !this.collegeModel.isCollegesNames;
				this.collegeList = [];
				this.collegeTotalPage = 0;
				this.collegeModel.page = 1;
			}
			this.getList(this.isTab, true);
		},
		// 点击我的意向省市
		handleCollegesArea() {
			if (this.isTab === 0) {
				this.majorModel.isCollegesAreas = !this.majorModel.isCollegesAreas;
				this.majorList = [];
				this.majorTotalPage = 0;
				this.majorModel.page = 1;
			} else {
				this.collegeModel.isCollegesAreas = !this.collegeModel.isCollegesAreas;
				this.collegeList = [];
				this.collegeTotalPage = 0;
				this.collegeModel.page = 1;
			}
			this.getList(this.isTab, true);
		},
		// 确认等效分
		handleSubmitScore() {
			if (this.isTab === 0) {
				this.majorModel.minScore = this.majorScore[0];
				this.majorModel.maxScore = this.majorScore[1];
				this.majorList = [];
				this.majorTotalPage = 0;
				this.majorModel.page = 1;
			} else {
				this.collegeModel.minScore = this.collegeScore[0];
				this.collegeModel.maxScore = this.collegeScore[1];
				this.collegeList = [];
				this.collegeTotalPage = 0;
				this.collegeModel.page = 1;
			}
			// RateMin  RateMax
			this.getList(this.isTab, true);
			this.isPop = false;
		},
		// 确认概率
		handlebability() {
			if (this.isTab === 0) {
				this.majorModel.RateMin = this.majorbability[0];
				this.majorModel.RateMax = this.majorbability[1];
				this.majorList = [];
				this.majorTotalPage = 0;
			} else {
				this.collegeModel.RateMin = this.collegebability[0];
				this.collegeModel.RateMax = this.collegebability[1];
				this.collegeList = [];
				this.collegeTotalPage = 0;
			}
			this.getList(this.isTab, true);
			this.babilityPop = false;
		},
		// 还原等效分
		resetScore() {
			if (this.isTab === 0) {
				this.majorScore[0] = this.scoreModel.stMajoScore + this.scoreModel.score;
				this.majorScore[1] = this.scoreModel.endMajoScore + this.scoreModel.score;
			} else {
				this.collegeScore[0] = this.scoreModel.stSchoolScore + this.scoreModel.score;
				this.collegeScore[1] = this.scoreModel.endSchoolScore + this.scoreModel.score;
			}
			this.isPop = false;
			this.$nextTick(() => {
				this.isPop = true;
			});
		},
		// 还原概率
		resetbability() {
			if (this.isTab === 0) {
				this.majorbability[0] = 1;
				this.majorbability[1] = 99;
				this.majorModel.RateMin = '';
				this.majorModel.RateMax = '';
			} else {
				this.collegebability[0] = 1;
				this.collegebability[1] = 99;
				this.collegeModel.RateMin = '';
				this.collegeModel.RateMax = '';
			}
			this.babilityPop = false;
			this.getList(this.isTab, true);
		},
		// 重置条件（点击刷新页面）
		resetCondition(getData = true) {
			this.restPop();
			if (this.isTab === 0) {
				this.majorModel = {
					...queryModel,
					userId: this.$store.state.user.userId,
					selectId: this.$parent.selectId,
					minScore: this.scoreModel.stMajoScore + this.scoreModel.score,
					maxScore: this.scoreModel.endMajoScore + this.scoreModel.score
				};
				this.majorList = [];
				this.majorTotalPage = 0;
				this.majorScore[0] = this.scoreModel.stMajoScore + this.scoreModel.score;
				this.majorScore[1] = this.scoreModel.endMajoScore + this.scoreModel.score;
				this.majorSearchCitysCode = [];
				this.preferredSubject = [];
				this.requirementsSubjects = [];
			} else {
				this.collegeModel = {
					...queryModel,
					userId: this.$store.state.user.userId,
					selectId: this.$parent.selectId,
					minScore: this.scoreModel.stSchoolScore + this.scoreModel.score,
					maxScore: this.scoreModel.endSchoolScore + this.scoreModel.score
				};
				this.collegeList = [];
				this.collegeTotalPage = 0;
				this.collegeScore[0] = this.scoreModel.stSchoolScore + this.scoreModel.score;
				this.collegeScore[1] = this.scoreModel.endSchoolScore + this.scoreModel.score;
				this.collegeSearchCitysCode = [];
			}
			
			console.log('selectedMajorId',this.selectedMajorId);
			
			getData && this.getList(this.isTab,true);
		},
		// 关注
		attentItem(scope) {
			scope.row.UserAttention = !scope.row.UserAttention;
			this.$api
				.accurateAttentionAdd({
					userId: this.$store.state.user.userId,
					contentId: scope.row.Id,
					type: this.isTab === 0 ? 2 : 1
				})
				.then(() => {
					this.$util.showOk(scope.row.UserAttention ? '关注成功' : '取消关注成功');
				})
				.catch(() => {
					scope.row.UserAttention = !scope.row.UserAttention;
				});
		},
		// 全选
		selectAll() {
			if (this.isTab === 0) {
				const selectedAll = this.majorList.some(a => !a.selected);
				// var dataList = this.pouplist.filter(a => a.Type !== 2);
				// this.pouplist = dataList;
				this.majorList.map(a => {
					a.selected = selectedAll;
				});
				this.majorList.forEach((a,ixd) => {
					if(selectedAll){
						if(!this.pouplist.some(p => p.major.Id==a.Id)){
							var item = {
								major: a,
								collegeList: [],
								Type: 2
							};
							this.pouplist.push(item);
						}
					}else{
						if(this.pouplist.length>0){
							this.pouplist.forEach((u,pxd) => {
								if(u.major.Id==a.Id){
									this.pouplist.splice(pxd, 1);
								}
							});
						}
					}
					
				});
				this.ZiTotal = this.pouplist.length || 0;
			} else {
				const selectedAll = this.collegeList.some(a => !a.selected);
				// var newList = this.pouplist.filter(a => a.Type !== 1);
				// this.pouplist = newList;
				this.selectedCollegeMajor = [];
				this.collegeList.map(a => {
					a.selected = selectedAll;
				});
				this.collegeList.forEach(a => {
					if(selectedAll){
						if(!this.pouplist.some(p => p.major.Id==a.Id)){
							var item = {
								major: a,
								collegeList: a.MajorList2,
								Type: 1
							};
							const selectedCollegeMajorObj = {
								id: a.Id,
								Type: 2,
								majorIdList: []
							};
							if(a.MajorList2){
								a.MajorList2.map(b => {
									selectedCollegeMajorObj.majorIdList.push(b.Id);
								});
							}
							this.selectedCollegeMajor.push(selectedCollegeMajorObj);
							this.pouplist.push(item);
						}
					}else{
						if(this.pouplist.length>0){
							this.pouplist.forEach((u,pxd) => {
								if(u.major.Id==a.Id){
									this.pouplist.splice(pxd, 1);
								}
							});
						}
					}
				});
				this.ZiTotal = this.pouplist.length || 0;
			}
		},
		// async setPoup(college) {
		// 	console.log('college', college);
		// 	if (college) {
		// 		const selectedCollegeMajorObj = {
		// 			id: college.Id,
		// 			Type: 2
		// 		};
		// 		const dto = {
		// 			CWBType: 0,
		// 			Characte: '',
		// 			CollegesMold: '',
		// 			CollegesType: '',
		// 			isCollegesAreas: false,
		// 			isCollegesNames: false,
		// 			isMajorNames: false,
		// 			maxScore: this.collegeModel.maxScore,
		// 			minScore: this.collegeModel.minScore,
		// 			page: 1,
		// 			preferredSubject: '',
		// 			requirementsSubjects: '',
		// 			searchCitysCode: '',
		// 			searchMajorName: '',
		// 			selectId: 12182,
		// 			totleScore: 579,
		// 			// ...this.collegeModel,
		// 			pageSize: 999999999,
		// 			searchCollegesName: college.CollegesName
		// 		};
		// 		const dtoStr = JSON.stringify(dto);
		// 		if (college.majorList && college.majorList[0].list) {
		// 			console.log('college.majorList[0].list', college.majorList[0].list);
		// 			const collegeMajorItem = college.majorList.find(a => a.dtoStr === dtoStr);
		// 			if (collegeMajorItem) {
		// 				item.collegeList = collegeMajorItem.list;
		// 				selectedCollegeMajorObj.majorIdList = collegeMajorItem.list.map(a => a.Id);
		// 				if (selectedCollegeMajorObj.majorIdList.length > 0) {
		// 					this.pouplist.push(item);
		// 					this.selectedCollegeMajor.push(selectedCollegeMajorObj);
		// 				} else {
		// 					console.log('55555555555555555');
		// 					this.$util.showError('该院校暂无可选择专业');
		// 					this.selectedCollegeMajor.push(selectedCollegeMajorObj);
		// 				}
		// 			}
		// 		} else {
		// 			var tongbu = await this.$api.getAccurateGetProfession(dto).then(res => {
		// 				const majorList = college.majorList || [];
		// 				const list = res.data.map(a => {
		// 					a.selected = false;
		// 					return a;
		// 				});
		// 				majorList.push({
		// 					dtoStr,
		// 					list
		// 				});
		// 				console.log('list', list);
		// 				college.majorList = majorList;
		// 				item.collegeList = list;
		// 				selectedCollegeMajorObj.majorIdList = list.map(a => a.Id);
		// 				if (selectedCollegeMajorObj.majorIdList.length > 0) {
		// 					this.selectedCollegeMajor.push(selectedCollegeMajorObj);
		// 				} else {
		// 					this.$util.showError('该院校暂无可选择专业');
		// 					this.selectedCollegeMajor.push(selectedCollegeMajorObj);
		// 				}
		// 				// this.pouplist.push(item);
		// 			}).catch(err => {
		// 				this.selectNum++;
		// 				console.log('err', err);
		// 			});
		// 		}
		// 		console.log('tongbu', tongbu);
		// 		return item;
		// 	}
		// },
		// 保存志愿
		save() {
			// const ids = this.majorList.filter(a => a.selected).map(a => a.Id);
			// console.log('************', this.selectedCollegeMajor);
			// const selectedCollegeList = this.selectedCollegeMajor.map(a => {
			// 	return {
			// 		collegeId: a.id,
			// 		professionIds: a.majorIdList.join(',')
			// 	};
			// });
			var that = this;
			var Type = 0;
			var selectedCollegeMajor = that.pouplist.filter(a => a.Type === 1);
			var Major = that.pouplist.filter(a => a.Type === 2);
			console.log('selectedCollegeMajor', selectedCollegeMajor);
			console.log('Major', Major);
			var selectedCollegeList = [];
			if (selectedCollegeMajor && selectedCollegeMajor.length > 0) {
				Type = 1;
				selectedCollegeList = selectedCollegeMajor.map(a => {
					return {
						collegeId: a.major.Id,
						professionIds: a.collegeList.map(a => a.Id).join(',')
					};
				});
			}
			var contentIds = '';
			if (Major && Major.length > 0) {
				Type = 2;
				contentIds = Major.map(a => a.major.Id).join(',');
			}
			if (selectedCollegeMajor && selectedCollegeMajor.length > 0 && (Major && Major.length > 0)) {
				Type = 3;
			}
			console.log('Type', Type);
			console.log('selectedCollegeList', selectedCollegeList);
			console.log('contentIds', contentIds);
			// if (ids.length === 0 && selectedCollegeList.length === 0) {
			// 	this.$util.showError('请至少选择一个专业或院校');
			// 	return;
			// }
			// if (this.isTab === 0) {
			//     ids = this.majorList.filter(a => a.selected).map(a => a.Id);
			//     if (ids.length === 0) {
			//         this.$util.showError('请至少选择一个专业');
			//         return;
			//     }
			// } else {
			//     selectedCollegeList = this.selectedCollegeMajor.filter(a => a.majorIdList.length > 0).map(a => {
			//         return {
			//             collegeId: a.id,
			//             professionIds: a.majorIdList.join(',')
			//         };
			//     });
			//     if (selectedCollegeList.length === 0) {
			//         this.$util.showError('请至少选择一个院校');
			//         return;
			//     }
			// }
			const loading = this.$loading({
				lock: true,
				text: '保存中，请耐心等待......',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			that.$newapi.HtppRequest(
				'Accurate/VolunteerSave',
				'POST',
				{
					userId: that.$store.state.user.userId,
					selectId: that.$parent.selectId,
					type: Type,
					contentIds: contentIds,
					contentList: JSON.stringify(selectedCollegeList)
				},
				function(res) {
					loading.close();
					if (res.code === 0) {
						that.$util.showOk('保存成功');
						// if (res.data) {
						// 	that.$api.reduceUserCount({
						// 		key: that.$route.query.key
						// 	});
						// }
						if (res.data) {
							var key = localStorage.getItem('YI_KEY');
							that.$api.reduceUserCount({
								key: key
							});
							localStorage.removeItem('YI_KEY');
						}
						that.cacheSelected();
						that.$parent.goNext(3);
					}
				},
				function(err) {
					loading.close();
					console.log(err);
				}
			);
			// Promise.all([
			// 	this.$api.accurateVolunteerSave({
			// 		userId: this.$store.state.user.userId,
			// 		selectId: this.$parent.selectId,
			// 		type: 1,
			// 		contentIds: contentIds,
			// 		contentList: JSON.stringify(selectedCollegeList)
			// 	}),
			// 	this.$api.accurateVolunteerSave({
			// 		userId: this.$store.state.user.userId,
			// 		selectId: this.$parent.selectId,
			// 		type: Type,
			// 		contentIds: contentIds,
			// 		contentList: JSON.stringify(selectedCollegeList)
			// 	})
			// ]).then(res => {
			// 	this.$util.showOk('保存成功');
			// 	if (res.some(a => a.data)) {
			// 		this.$api.reduceUserCount({
			// 			key: this.$route.query.key
			// 		});
			// 	}
			// });
			// this.$api
			//     .accurateVolunteerSave({
			//         userId: this.$store.state.user.userId,
			//         selectId: this.$parent.selectId,
			//         type: this.isTab === 0 ? 2 : 1,
			//         contentIds: ids.join(','),
			//         contentList: JSON.stringify(selectedCollegeList)
			//     })
			//     .then(res => {
			//         this.$util.showOk('保存成功');
			//         if (res.data) {
			//             this.$api.reduceUserCount({ key: this.$route.query.key });
			//         }
			//     });
		},
		// 显示专业介绍
		showMajorDetail(scope) {
			if (scope.row.MajorProfile) {
				this.majorDetail = scope.row.MajorProfile;
			} else {
				this.majorDetail = scope;
			}
			this.isZyPop = true;
		},
		// 搜索
		goSearch() {
			this.isTab === 0 ? (this.majorList = []) : (this.collegeList = []);
			var that = this;
			var searchCitysCode = '';
			if (that.yuanShuList && that.yuanShuList.length > 0) {
				searchCitysCode = that.yuanShuList
					.filter(a => {
						if (a.isSelect) {
							return a;
						}
					})
					.map(b => {
						return b.name;
					})
					.join(',');
				if (searchCitysCode === '不限') {
					searchCitysCode = '';
				}
			}
			var CollegesMold = '';
			if (that.yuanShubList && that.yuanShubList.length > 0) {
				CollegesMold = that.yuanShubList
					.filter(a => {
						if (a.isSelect) {
							return a;
						}
					})
					.map(b => {
						return b.name;
					})
					.join(',');
				if (CollegesMold === '不限') {
					CollegesMold = '';
				}
			}
			var Characte = '';
			if (that.yuanShucList && that.yuanShucList.length > 0) {
				Characte = that.yuanShucList
					.filter(a => {
						if (a.isSelect) {
							return a;
						}
					})
					.map(b => {
						return b.name;
					})
					.join(',');
				if (Characte === '不限') {
					Characte = '';
				}
			}
			var CollegesType = '';
			if (that.yuanShudList && that.yuanShudList.length > 0) {
				CollegesType = that.yuanShudList
					.filter(a => {
						if (a.isSelect) {
							return a;
						}
					})
					.map(b => {
						return b.name;
					})
					.join(',');
				if (CollegesType === '不限') {
					CollegesType = '';
				}
			}
			var zyavalue = '';
			if (this.zyavalue) {
				zyavalue = this.zyavalue
					.map(a => {
						return a;
					})
					.join(',');
			}
			if (this.isTab === 1) {
				this.collegeModel.page = 1;
				this.collegeModel.searchCitysCode = searchCitysCode;
				this.collegeModel.CollegesTypes = CollegesType;
				this.collegeModel.CollegesMolds = CollegesMold;
				this.collegeModel.Characte = Characte;
				this.collegeModel.AdmissionBatch = this.ppcvalue;
				// this.collegeModel.selectMajorNames = zyavalue;
				// this.collegeModel.searchCollegesName = this.YXName;
			} else {
				this.majorModel.page = 1;
				this.majorModel.searchCitysCode = searchCitysCode;
				this.majorModel.CollegesTypes = CollegesType;
				this.majorModel.CollegesMolds = CollegesMold;
				this.majorModel.Characte = Characte;
				this.majorModel.AdmissionBatch = this.pcvalue;
				this.majorModel.selectMajorNames = zyavalue;
				// this.majorModel.searchMajorName = this.zyName;
				// this.majorModel.searchCollegesName = this.YXName;
				// this.majorModel.searchMajorName = this.pcvalue;
			}
			this.getList(this.isTab, true);
		},
		restPop() {
			var that = this;
			that.form = {};
			that.yuanShuList.forEach(a => {
				a.isSelect = false;
				if (a.name === '不限') {
					a.isSelect = true;
				}
			});
			that.yuanShubList.forEach(a => {
				a.isSelect = false;
				if (a.name === '不限') {
					a.isSelect = true;
				}
			});
			that.yuanShucList.forEach(a => {
				a.isSelect = false;
				if (a.name === '不限') {
					a.isSelect = true;
				}
			});
			that.yuanShudList.forEach(a => {
				a.isSelect = false;
				if (a.name === '不限') {
					a.isSelect = true;
				}
			});
		},
		// 专业选择/院校选择切换
		xuanZeTo(index) {
			if (this.isTab !== index) {
				this.isPage = false;
				if (index) {
					this.ANoData = false;
					this.AisLoading = false;
					this.BisLoading = true;
				} else {
					this.BNoData = false;
					this.BisLoading = false;
					this.AisLoading = true;
				}
			}
			this.isTab = index;
			!this.collegeLoaded && index === 1 && this.getList(1, true);
			!this.majorLoaded && index === 0 && this.getList(0, true);
		},
		// 跳转专业
		zhunYe(item) {
			// this.isZhuan = true;
			this.GetProfessionaScoreByColleges(item);
		},
		GetProfessionaScoreByColleges(item) {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/GetProfessionaScoreByColleges?cityCode=' +
					item.CollegesArea +
					'&candidatesType=' +
					item.CollegesType +
					'&collegesName=' +
					item.CollegesName +
					'&year=' +
					item.NewYear +
					'&collegesCode=' +
					item.Id,
				'GET',
				{},
				function(res) {
					console.log('获取学院专业', res);
					if (res.flag) {
						var Info = res.list;
						that.zhuanList = Info;
						that.isZhuan = true;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		zhunYeye(item) {
			this.zhuanList = item.MajorProfile;
			this.ZyNoData = this.zhuanList.length === 0;
			this.isZhuan = true;
		},
		// 跳转学校 22.2.15
		xueTo(item) {
			// this.isXueYuan = true;
			console.log('跳转学校',item);
			this.XiaoList = item.CollegeProfile;
			this.XiaoNoData = this.XiaoList.length === 0;
			this.isXueYuan = true;
			// this.QueryCollege(item);
		},
		QueryCollege(item) {
			var that = this;
			var form = {
				page: 1,
				size: 9999,
				name: item.CollegesName
			};
			that.$api.HtppRequest(
				'SystemData/GetIntendedCollegesByPage',
				'POST',
				form,
				function(res) {
					console.log('查询院校列表', res);
					if (res.flag) {
						var Info = res.list;
						that.XiaoList = Info;
						that.isXueYuan = true;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		// xueTo(name) {

		//    window.open(`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${name}`);

		// },
		// 跳转志愿表/下一步
		goVolunteerTable() {
			this.cacheSelected();
			this.$parent.goNext(3);
		},
		// 上一步
		goPrev() {
			this.cacheSelected();
			this.$parent.goNext(1);
		},
		// 缓存已经选择的数据
		cacheSelected() {
			// this.$parent.setMajorId(this.majorList.filter(a => a.selected).map(a => a.Id));
			// this.$parent.setSelectedCollegeMajor(this.selectedCollegeMajor.filter(a => a.majorIdList.length > 0));
		},
		// 前往专业详情页
		goMajorInfo(id) {
			window.open(`${window.location.origin}${window.location.pathname}#/majorinfo?Id=${id}`);
		}
	}
};
</script>
<style scoped>
.centerWidth {
	width: 1400px !important;
}

.pt_add p {
	width: 50px;
	height: 50px;
	border-radius: 4px;
	background-color: #444444;
	font-size: 14px;
	color: #fff;
	text-align: center;
	line-height: 50px;
	margin: 0 auto;
}

.pt_add_b {
	padding: 10px;
	color: #444 !important;
	background-color: #fff !important;
	box-sizing: border-box;
	border: solid 1px #444444;
	line-height: initial;
	padding: 0 10px !important;
	display: flex;
	align-items: center;
	justify-content: center;
}

.pt_add {
	cursor: pointer;
}

.zhi_imga {
	display: block;
	width: 53px;
	height: 90%;
	position: absolute;
	left: 0;
	top: 52px;
	margin-top: 0;
	z-index: 1;
	overflow: auto;
	overflow-x: hidden;
}

.zhi_imga::-webkit-scrollbar {
	width: 0px;
	height: 0px;
	color: transparent;
}

.zhi_kedu {
	width: 53px;
}

.zhi_h {
	overflow: auto;
	height: calc(100% - 24px);
}

.xhi_libox span {
	display: inline-block;
	width: 55px;
}

.xhi_lidiv > p {
	max-width: 380px;
}

.xhi_lidiv p {
	font-size: 14px;
	color: #000000;
}

.xhi_lidiv {
	margin-top: 12px;
}

.zhi_lileft h6 i {
	font-weight: normal;
	font-style: normal;
	display: inline-block;
	width: 22px;
	height: 22px;
	border-radius: 4px;
	background-color: #ffe4e2;
	color: #fa4237;
	border: solid 1px #fa4237;
	text-align: center;
	line-height: 22px;
	margin-right: 10px;
}

.zhi_lileft.orange h6 i {
	background-color: #fff8ec;
	color: #f3af3b;
	border: solid 1px #f3af3b;
}

.zhi_lileft.orange span {
	color: #f3af3b;
}

.zhi_lileft.green h6 i {
	background-color: #eeffee;
	color: #66b864;
	border: solid 1px #66b864;
}

.zhi_lileft.green span {
	color: #66b864;
}

.zhi_lileft h6 {
	max-width: 380px;
	font-size: 16px;
	color: #333;
}

.zhi_lileft span {
	font-size: 16px;
	color: #fa4237;
	display: inline-block;
	margin-left: 10px;
}

.zhi_btn p {
	width: 70px;
	height: 30px;
	border-radius: 4px;
	background-color: #ddebf7;
	font-size: 14px;
	color: #666666;
	text-align: center;
	line-height: 30px;
	margin-left: 10px;
}

.zhi_del_img {
	display: block;
	width: 20px;
	height: 20px;
	margin-left: 20px;
}

.zhi_list li {
	padding: 20px;
	box-sizing: border-box;
	border-radius: 4px;
	margin-top: 20px;
	width: 100%;
	border: solid 1px #dddddd;
}

/* zhi_list */

/deep/.el-input__inner {
	padding-right: 0;
}

.zhi_head_a {
	width: 120px;
}

.zhi_head_li h6 {
	font-size: 18px;
	color: #fa4237;
	width: 40px;
	text-align: left;
	position: absolute;
	left: 0;
	top: 35px;
	margin: 0;
	z-index: 2;
}

.zhi_head_a:last-child {
	position: absolute;
	left: 160px;
	top: 33px;
	margin: 0;
	z-index: 1;
}

.zhi_head_li {
	padding-left: 40px;
	position: relative;
}

.zhi_head {
	padding: 20px;
	border-radius: 6px;
	background-color: #f5f5f5;
	margin-top: 10px;
}

.zhi_fg img {
	display: block;
	width: 22px;
	height: 22px;
	margin-left: 12px;
}

.zhi_fg {
	font-size: 16px;
	color: #005371;
}

.zhi_gao {
	padding: 0 20px;
}

.zhi_popup {
	height: 690px;
	background-color: #fff;
	width: 790px;
	padding: 20px 0;
	position: absolute;
	left: -805px;
	top: 33%;
	z-index: 1;
	box-shadow: 0px 0px 10px #e7e7e7;
	margin-top: -400px;
}

.pt_you {
	position: fixed;
	position: fixed;
	right: 50px;
	bottom: 67px;
	z-index: 10;
	width: 50px !important;
}

.city_gao li {
	width: 33.33%;
}

.city_gao {
	height: 300px;
	overflow: auto;
}

/* 22.2.15 */
.pt_you_kuan > p.green {
	color: #42ab3f;
	background-color: #eeffee;
	border: solid 1px #42ab3f;
}

.pt_you_kuan > p.yellow {
	color: #f3af3b;
	background-color: #fff8ec;
	border: solid 1px #f3af3b;
}

.pt_you_kuan > p {
	width: 50px;
	height: 50px;
	border-radius: 4px;
	color: #fa4237;
	background-color: #ffe4e2;
	border: solid 1px #fa4237;
	margin-top: 8px;
	text-align: center;
	line-height: 50px;
	font-size: 20px;
}

.pt_youc img {
	display: block;
	width: 100%;
	height: 100%;
}

.pt_youc {
	width: 50px;
	height: 50px;
	border-radius: 4px;
	border: solid 1px #d8d8d8;
	overflow: hidden;
	margin-top: 8px;
	cursor: pointer;
	position: fixed;
	right: 50px;
	bottom: 100px;
	z-index: 10;
}

.pt_youb {
	background-color: #fff;
	width: 50px;
	height: 50px;
	line-height: 50px;
	text-align: center;
	border: solid 1px #169bd5;
	color: #169bd5;
	border-radius: 4px;
	text-align: center;
	margin-top: 8px;
	cursor: pointer;
}

.pt_youa {
	width: 50px;
	border-radius: 4px;
	background-color: #005371;
	font-size: 12px;
	color: #fff;
	height: 126px;
	text-align: center;
	flex-direction: column;
	display: flex;
	align-items: center;
	justify-content: center;
}

.pt_youa span {
	writing-mode: vertical-lr;
	/*从左向右 从右向左是 writing-mode: vertical-rl;*/
	writing-mode: tb-lr;
	/*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
	width: 100%;
	display: flex;
	align-items: center;
	line-height: 16px;
	letter-spacing: 4px;
	padding-top: 4px;
}

.pt_you_kuan {
	width: 50px;
}

.pt_you {
	width: 200px;
	height: fit-content;
	padding-bottom: 93px;
}

/* pt_you */

.zhuan_bai button {
	width: 200px;
	height: 40px;
	border-radius: 4px;
	background-color: #444444;
	font-size: 14px;
	color: #fff;
	text-align: center;
	line-height: 40px;
	margin: 0 auto;
	display: block;
	cursor: pointer;
}

.city_gao li {
	width: 33.33%;
}

.city_gao {
	height: 300px;
	overflow: auto;
}

.zhuan_bai > img {
	display: block;
	width: 20px;
	height: 20px;
	position: absolute;
	right: 20px;
	top: 20px;
	z-index: 2;
	cursor: pointer;
}

.zhuan_list p {
	width: 130px;
	height: 40px;
	background-color: #e6e6e6;
	text-align: center;
	line-height: 40px;
	text-align: center;
	font-size: 14px;
	border-radius: 4px;
	margin-top: 14px;
	margin-right: 20px;
}

.zhuan_list p:active {
	background-color: #00527020;
}

.zhuan_list p:nth-child(3n + 3) {
	margin-right: 0;
}

.zhuan_h6 {
	text-align: center;
	font-size: 18px;
	color: #333333;
	font-weight: normal;
}

.zhuan_bai {
	border-radius: 10px;
	width: 510px;
	overflow: hidden;
	padding: 20px 40px;
	background-color: #fff;
	position: relative;
}

/* zhuan_bai */

.tb_city li p {
	width: 24px;
	height: 24px;
	border-radius: 50px;
	background-color: #005270;
	color: #fff;
	text-align: center;
	line-height: 24px;
	font-size: 12px;
	text-align: center;
	line-height: 24px;
	position: absolute;
	right: -9px;
	top: -9px;
	margin: 0;
	z-index: 1;
}

.yi_hot_div p.on {
	color: #fff;
	background-color: #005371;
	border: solid 1px #005371;
}

.yi_hot_div p {
	width: 90px;
	height: 36px;
	box-sizing: border-box;
	padding: 0 10px;
	font-size: 14px;
	color: #666666;
	text-align: center;
	line-height: 36px;
	border: solid 1px #444444;
	cursor: pointer;
	margin-right: 10px;
	margin-top: 10px;
}

.yi_hot_div {
	width: calc(100% - 92px);
}

.yi_hot > p {
	font-size: 14px;
	color: #333333;
	line-height: 36px;
	margin-top: 10px;
}

.yi_hot {
	padding: 14px 0;
}

.yi_head p span {
	color: #0079fe;
}

.yi_head p {
	font-size: 14px;
	color: #333333;
}

.yi_head button {
	width: 70px;
	height: 30px;
	background-color: #fff;
	border-radius: 4px;
	border: solid 1px #dedede;
	text-align: center;
	line-height: 30px;
	display: block;
	margin: 0 23px;
	cursor: pointer;
}

.yi_all span {
	font-size: 14px;
	color: #333333;
}

.yi_all img {
	display: block;
	width: 40px;
	height: 40px;
	cursor: pointer;
}

/* 2.14 */

.show-colloge-major {
	padding: 20px 0;
	cursor: pointer;
}

/* state-type */
.state-type {
	width: 100%;
	height: auto;
}

.state-type p {
	font-size: 15px;
	color: #333;
	width: 80px;
	text-align: center;
	position: relative;
	cursor: pointer;
}

.state-type p::after {
	position: absolute;
	content: '';
	width: 40px;
	height: 0;
	border-bottom: 3px solid transparent;
	border-radius: 50px;
	bottom: 0;
	left: 50%;
	margin-left: -20px;
}

.state-type .on-type {
	color: #0079fe;
	font-weight: bold;
}

.state-type .on-type::after {
	border-bottom: 3px solid #0079fe;
}

.red-text {
	color: red !important;
}

.aside_height li {
	border-bottom: solid 1px #eeeeee;
	padding: 14px 0;
	text-indent: 1em;
	font-size: 14px;
	color: #666666;
}

.aside_height {
	height: 320px;
	overflow-y: auto;
	border-radius: 6px;
	border: solid 1px #eeeeee;
}

.tbc_tabel.active /deep/.el-table--border td {
	background-color: #fff4ee;
}

/deep/.el-table thead.is-group th {
	background-color: #bddcf6;
}

/deep/.el-table--border td {
	background-color: #ddebf7;
}

.name_div > p {
	font-size: 12px !important;
	color: #999 !important;
	text-align: left !important;
}

.name_div > p span {
	color: #666 !important;
}

.table img.scImg {
	display: block;
	width: 20px;
	height: 20px;
	margin: 0 auto;
	cursor: pointer;
}

.table p {
	text-align: center;
	font-size: 13px;
	font-weight: normal;
	color: #333;
}

/deep/.el-table td,
/deep/.el-table th {
	padding: 5px 0 !important;
}

/deep/.cell {
	text-align: center;
	font-size: 13px;
	font-weight: normal;
	color: #333;
}

.table p span {
	font-size: 13px;
	color: #333;
	padding-bottom: 8px;
	border-bottom: solid 1px #333;
	line-height: initial;
	margin: 0 10px;
	cursor: pointer;
}

.table li p {
	font-size: 13px;
	width: calc(100% / 6);
	line-height: 60px;
	text-align: center;
	color: #666666;
}

.table li:last-child {
	border-bottom: none;
}

.table li p:last-child {
	border-right: none;
}

.table li {
	border-bottom: solid 1px #e6e6e6;
}

.table ul {
	overflow: hidden;
}

.table hgroup p {
	font-size: 14px;
	background-color: #eaeaea;
	width: calc(100% / 6);
	line-height: 60px;
	text-align: center;
}

.table {
	height: 500px;
	overflow: auto;
	border: solid 1px #e6e6e6;
	box-sizing: border-box;
}

/* 01 */

.tbc_tabel {
	width: 100%;
	margin-top: 20px;
	/*    height: 600px;
    overflow: auto; */
}

/* tbc_tabel */

.aside_btn .zhun_btn {
	background-color: #333;
	border: solid 1px #333;
}

.aside_btn .zhun_btn:first-child {
	background-color: #fff;
	color: #333;
	border: solid 1px #333;
}

.aside_btn {
	margin-top: 40px;
}

.aside_box {
	width: 70%;
	margin: 0 10px;
}

.aside_div {
	width: 90%;
	margin: 0 auto;
}

.aside_pop {
	width: 520px;
	border-radius: 10px;
	background-color: #fff;
	padding: 50px 20px 20px 20px;
}

.relative {
	position: relative;
}

.close-icon {
	position: absolute;
	right: 5px;
	top: 5px;
	font-size: 22px;
	cursor: pointer;
}

/* aside_pop */

/deep/.el-slider__button-wrapper:nth-child(2)::before {
	content: '-';
	font-size: 18px;
	font-weight: bold;
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 1;
	text-align: center;
	line-height: 35px;
}

/deep/.el-slider__button-wrapper:nth-child(3)::before {
	content: '+';
	font-size: 18px;
	font-weight: bold;
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 1;
	text-align: center;
	line-height: 35px;
}

/deep/.el-slider__button {
	width: 24px;
	height: 24px;
	background-color: #fff;
	border: solid 1px #dddddd;
	border-radius: 4px;
}

/deep/.el-slider__bar {
	background-color: #f3af3b;
}

/deep/.el-slider__runway {
	background-color: #fce4d6;
}

/deep/.el-slider__stop {
	background-color: transparent;
}

.block {
	width: 360px;
	margin: 0 20px;
}

.aside_div /deep/input {
	padding: 0 !important;
	text-align: center;
}

.tba_dl p {
	font-size: 14px;
	color: #333;
	margin: 0 10px;
}

.tba_dl label {
	font-size: 14px;
	color: #333;
	width: 80px;
	text-align: right;
	margin-right: 10px;
}

.tba_dl {
	min-width: 300px;
}

.div_padding li:nth-child(n + 2) {
	margin-top: 5px;
}

.zhun_btn.on {
	background-color: #005371 !important;
}

.zhun_btn {
	width: 106px;
	height: 40px;
	background-color: #666;
	border-radius: 4px;
	font-size: 14px;
	color: #fff;
	line-height: 40px;
	margin-right: 20px;
	display: block;
	cursor: pointer;
}

.zhun_btn:last-child {
	margin-right: 0;
}

/* zhun_btn */

.div_padding {
	padding: 20px;
	width: 100%;
	border: solid 1px #dddddd;
	margin: 20px 0;
}

/* div_padding */

.three_div p.on {
	background-color: #333;
	color: #fff;
}

.three_div p {
	width: 180px;
	height: 40px;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
	border: solid 1px #dddddd;
	border-bottom: none;
	font-size: 16px;
	color: #333;
	line-height: 40px;
	text-align: center;
	cursor: pointer;
}

.three_div {
	margin: 20px 0;
	border-bottom: solid 2px #333;
}

/* three_div */
.tb_padding {
	padding: 20px 20px 1px 20px;
}

.gkTest-step {
	margin-top: 0;
}

.gaokao-content {
	background-color: #fff;
	margin-bottom: 40px;
	/* padding-bottom: 40px; */
	overflow: auto;
	overflow-x: hidden;
}

.tba_input /deep/.el-input {
	width: 210px;
}

.ptsee {
	position: relative;
	cursor: pointer;
}

.ptsee::after {
	content: '';
	width: 65px;
	height: 1px;
	background-color: #94918f;
	position: absolute;
	left: 50%;
	margin-left: -32.5px;
	bottom: 0;
	z-index: 1;
}

.zhi_num {
	position: absolute;
	left: 0;
	top: -5px;
	margin-top: 0;
	z-index: 2;
}

.zhi_num p {
	padding-left: 23px;
	font-size: 12px;
	color: #000;
	font-weight: bold;
	padding-bottom: 11px;
}

.kedu_dd {
	border-left: solid 4px #fd0000;
	padding-top: 3px;
}

.kedu_dd.yellow {
	border-left: solid 4px #fed347;
}

.kedu_dd.green {
	border-left: solid 4px #8dc11c;
}

.kedu_dd span {
	width: 6px;
	display: block;
	height: 2px;
	margin-top: 4px;
	background-color: #919191;
}

.kedu_dd .ke_li:first-child span {
	width: 12px;
	margin-top: 0;
}

.ke_li {
	width: 15px !important;
	position: relative;
}

.ke_li p {
	font-size: 14px;
	position: absolute;
	right: 0;
	top: 0;
	z-index: 1;
	color: #666;
}

.jiazai {
	font-size: 14px;
	color: #666;
	text-align: center;
	padding: 30px 0;
}

.pta {
	position: relative;
}

.pta p {
	position: absolute;
	right: 0;
	top: -9px;
	z-index: 1;
}

.pt_yuan {
	width: 210px;
	height: 280px;
	background-color: #fff;
	margin: 5px 0;
	overflow: auto;
	box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
	border-radius: 4px;
	border: 1px solid #e4e7ed;
	box-sizing: border-box;
	background-color: #fff;
	position: absolute;
	left: 0;
	top: 40px;
	z-index: 1;
}

.pt_yuan li {
	padding: 0 20px;
	margin: 0;
	line-height: 28px;
	cursor: pointer;
	color: #606266;
	font-size: 14px;
	list-style: none;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.pt_yuan ul li.red {
	color: #ff0000;
}

.pt_yuan ul li {
	margin-top: 0 !important;
}

.pt_yuan ul {
	max-height: 280px;
	overflow: scroll;
	height: 100%;
	padding: 10px 0;
	box-sizing: border-box;
	overflow-x: hidden;
}

.pt_yuan ul::-webkit-scrollbar {
	width: 0 !important;
}

.pt_yuan::after {
	content: ' ';
	border-width: 6px;
	position: absolute;
	display: block;
	width: 0;
	height: 0;
	border-color: transparent;
	border-style: solid;
	top: 1px;
	margin-left: -6px;
	border-top-width: 0;
	border-bottom-color: #fff;
}

.xtianbao_h1 {
	padding: 0 20px;
	width: 100%;
	margin: 20px 0 0 0;
	height: auto;
	overflow: hidden;
	background-color: #fff;
}

.pptnei_liab::after {
	right: 99px;
}

.pptnei_liab::before {
	left: 98px;
}

.lanse {
	background-color: #e5edf1 !important;
}
</style>
<style>
body::-webkit-scrollbar {
	width: 0 !important;
}
</style>
